import './demofloorsvg.less'

import {classes} from '@codeurs/front'
import React from 'react'

export const DemofloorSVG: React.FC<{
	light: boolean
}> = ({light}) => (
	<svg
		id="demofloor"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 1095.85 1027.56"
		{...classes('demofloorsvg', {is: {light, dark: !light}})}
	>
		<g id="sponsors">
			<g>
				<g id="c">
					<g>
						<g>
							<rect
								className="fj"
								x="628.2"
								y="746.9"
								transform="matrix(0.2419 -0.9703 0.9703 0.2419 -277.5476 1216.7494)"
								width="23.4"
								height="78.2"
							/>
							<path
								className="fo"
								d="M675.4,807.4l-76.8-19.2l5.9-23.7l76.8,19.2L675.4,807.4z M599.7,787.5l74.9,18.7l5.4-21.7l-74.9-18.7
							L599.7,787.5z"
							/>
						</g>
					</g>
				</g>
				<g className="fk">
					<path
						className="ff"
						d="M622,782.5c-0.1,0.6-0.4,1-0.9,1.2c-0.4,0.3-1,0.3-1.7,0.1c-0.4-0.1-0.7-0.2-1-0.4
					c-0.3-0.2-0.5-0.3-0.7-0.6l0.2-1.4c0.4,0.6,1,1,1.7,1.1c0.3,0.1,0.5,0.1,0.6,0c0.2-0.1,0.3-0.2,0.3-0.4c0-0.2,0-0.3-0.1-0.5
					c-0.1-0.1-0.3-0.3-0.6-0.5c-0.5-0.3-0.8-0.6-1-1c-0.2-0.4-0.2-0.8-0.1-1.2c0.1-0.2,0.2-0.5,0.3-0.7s0.3-0.3,0.5-0.5
					c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.6,0,0.9,0.1c0.4,0.1,0.7,0.2,0.9,0.3c0.2,0.1,0.4,0.3,0.5,0.4l-0.4,1.2
					c-0.1-0.1-0.3-0.2-0.5-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.1-0.6,0c-0.1,0.1-0.2,0.2-0.3,0.3s0,0.3,0.1,0.4
					c0.1,0.1,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.2,0.6
					C622.1,782,622.1,782.3,622,782.5z"
					/>
					<path
						className="ff"
						d="M627.4,781.4c-0.1,0.3-0.2,0.5-0.3,0.7c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.2s-0.5,0-0.7-0.1
					l-0.8-0.2l-0.6,2.3l-1.4-0.3l1.4-5.8l2.1,0.5c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.3,0.7
					C627.5,780.8,627.4,781.1,627.4,781.4z M626,781c0.1-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.2-0.5-0.3l-0.6-0.1l-0.3,1.3l0.6,0.1
					c0.2,0,0.4,0,0.5,0S626,781.3,626,781z"
					/>
					<path
						className="ff"
						d="M633.8,784.2c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.3-0.6,0.6-0.9,0.8c-0.4,0.2-0.7,0.3-1.2,0.4
					c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.6-0.5-0.8-0.9c-0.2-0.3-0.4-0.7-0.5-1.1c-0.1-0.4-0.1-0.9,0.1-1.3
					c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,0.9-0.8c0.4-0.2,0.7-0.3,1.1-0.4s0.8,0,1.2,0.1s0.8,0.3,1.1,0.5
					c0.3,0.2,0.6,0.5,0.8,0.9c0.2,0.3,0.4,0.7,0.5,1.1C633.9,783.3,633.9,783.7,633.8,784.2z M632.4,783.8c0.1-0.3,0.1-0.5,0-0.8
					c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.7,0c-0.2,0-0.4,0.1-0.6,0.2
					c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.3,0.4-0.3,0.7c-0.1,0.3-0.1,0.5,0,0.8c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.5
					c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.1,0.7,0c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.3,0.5-0.5
					C632.2,784.3,632.3,784.1,632.4,783.8z"
					/>
					<path
						className="ff"
						d="M638.6,788.5l-1.6-3c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.3-0.3-0.5-0.4-0.8l0,0c0,0.2-0.1,0.4-0.1,0.6
					c0,0.2-0.1,0.4-0.1,0.6l-0.6,2.5l-1.4-0.4l1.4-5.8l1.1,0.3l1.4,2.7c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.3,0.2,0.5,0.3,0.7l0,0
					c0.1-0.4,0.1-0.7,0.2-1.1l0.5-2.2l1.4,0.4l-1.5,5.9L638.6,788.5z"
					/>
					<path
						className="ff"
						d="M644.6,788.1c-0.1,0.6-0.4,1-0.9,1.2c-0.4,0.3-1,0.3-1.7,0.1c-0.4-0.1-0.7-0.2-1-0.4
					c-0.3-0.2-0.5-0.3-0.7-0.6l0.2-1.4c0.4,0.6,1,1,1.7,1.1c0.3,0.1,0.5,0.1,0.6,0c0.2-0.1,0.3-0.2,0.3-0.4c0-0.2,0-0.3-0.1-0.5
					c-0.1-0.1-0.3-0.3-0.6-0.5c-0.5-0.3-0.8-0.6-1-1c-0.2-0.4-0.2-0.8-0.1-1.2c0.1-0.2,0.2-0.5,0.3-0.7s0.3-0.3,0.5-0.5
					c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.6,0,0.9,0.1c0.4,0.1,0.7,0.2,0.9,0.3c0.2,0.1,0.4,0.3,0.5,0.4l-0.4,1.2
					c-0.1-0.1-0.3-0.2-0.5-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.1-0.6,0c-0.1,0.1-0.2,0.2-0.3,0.3s0,0.3,0.1,0.4
					c0.1,0.1,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.2,0.6
					C644.7,787.7,644.7,787.9,644.6,788.1z"
					/>
					<path
						className="ff"
						d="M651.7,788.6c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.3-0.6,0.6-0.9,0.8c-0.4,0.2-0.7,0.3-1.2,0.4
					c-0.4,0.1-0.8,0-1.2-0.1s-0.8-0.3-1.1-0.5c-0.3-0.2-0.6-0.5-0.8-0.9c-0.2-0.3-0.4-0.7-0.5-1.1c-0.1-0.4-0.1-0.9,0.1-1.3
					c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,0.9-0.8c0.4-0.2,0.7-0.3,1.1-0.4c0.4,0,0.8,0,1.2,0.1s0.8,0.3,1.1,0.5
					s0.6,0.5,0.8,0.9c0.2,0.3,0.4,0.7,0.5,1.1C651.8,787.7,651.8,788.2,651.7,788.6z M650.3,788.3c0.1-0.3,0.1-0.5,0-0.8
					c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.7,0c-0.2,0-0.4,0.1-0.6,0.2
					c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.3,0.4-0.3,0.7c-0.1,0.3-0.1,0.5,0,0.8c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.5
					c0.2,0.1,0.4,0.2,0.6,0.3s0.4,0.1,0.7,0c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.3,0.5-0.5C650.1,788.8,650.2,788.6,650.3,788.3z"
					/>
					<path
						className="ff"
						d="M655.2,792.6l-1-2.7l-0.5-0.1l-0.6,2.3l-1.4-0.3l1.4-5.8l2.2,0.5c0.2,0.1,0.5,0.2,0.7,0.3s0.4,0.3,0.5,0.5
					c0.1,0.2,0.2,0.4,0.3,0.7s0,0.5,0,0.8c-0.1,0.3-0.2,0.6-0.5,0.8c-0.2,0.2-0.5,0.3-0.8,0.4l1.2,3.1L655.2,792.6z M655.5,788.4
					c0.1-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.2-0.5-0.3l-0.6-0.1l-0.3,1.3l0.6,0.1c0.2,0,0.4,0,0.5,0
					C655.3,788.8,655.4,788.6,655.5,788.4z"
					/>
					<path
						className="ff"
						d="M661.4,792.3c-0.1,0.6-0.4,1-0.9,1.2c-0.4,0.3-1,0.3-1.7,0.1c-0.4-0.1-0.7-0.2-1-0.4
					c-0.3-0.2-0.5-0.3-0.7-0.6l0.2-1.4c0.4,0.6,1,1,1.7,1.1c0.3,0.1,0.5,0.1,0.6,0c0.2-0.1,0.3-0.2,0.3-0.4c0-0.2,0-0.3-0.1-0.5
					c-0.1-0.1-0.3-0.3-0.6-0.5c-0.5-0.3-0.8-0.6-1-1c-0.2-0.4-0.2-0.8-0.1-1.2c0.1-0.2,0.2-0.5,0.3-0.7s0.3-0.3,0.5-0.5
					c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.6,0,0.9,0.1c0.4,0.1,0.7,0.2,0.9,0.3c0.2,0.1,0.4,0.3,0.5,0.4l-0.4,1.2
					c-0.1-0.1-0.3-0.2-0.5-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.1-0.6,0c-0.1,0.1-0.2,0.2-0.3,0.3s0,0.3,0.1,0.4
					c0.1,0.1,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.2,0.6
					C661.4,791.8,661.4,792.1,661.4,792.3z"
					/>
				</g>
			</g>
		</g>
		<g id="demo55">
			<g>
				<g>
					<rect
						className="fs"
						x="421"
						y="468.12"
						width="23.4"
						height="39.1"
						transform="translate(-181.55 706.19) rotate(-68)"
					/>
					<path
						className="fi"
						d="M446.72,506.49l-37.18-15.02,9.14-22.62,37.18,15.02-9.14,22.62Zm-35.88-15.57l35.33,14.27,8.39-20.77-35.33-14.27-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="432.65" cy="487.7" r="7.8" />
				<g id="e" className="fk">
					<path
						className="fi"
						d="M431.83,488.34c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.27,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
					/>
					<path
						className="fi"
						d="M435.77,489.94c-.11,.28-.26,.51-.44,.7-.18,.19-.4,.33-.64,.42-.25,.09-.52,.13-.82,.11-.3-.02-.62-.1-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.19c.13,.15,.27,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.05,.23-.07,.39-.22,.48-.44,.1-.24,.09-.47-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.12,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.09,.02c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38s.3,.36,.4,.58c.1,.22,.15,.46,.16,.72,0,.26-.04,.51-.15,.78Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo54">
			<g>
				<g>
					<rect
						className="fs"
						x="388.32"
						y="458.67"
						width="23.4"
						height="31.3"
						transform="translate(-189.61 667.53) rotate(-68)"
					/>
					<path
						className="fi"
						d="M410.42,491.68l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="399.95" cy="474.4" r="7.8" />
				<g id="g" className="fk">
					<path
						className="fi"
						d="M398.9,475.04c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.26,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
					/>
					<path
						className="fi"
						d="M402.65,477.01l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.96-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.07-.19,.16-.37,.25-.56h-.01Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo53">
			<g>
				<g>
					<rect
						className="fs"
						x="359.49"
						y="446.97"
						width="23.4"
						height="31.3"
						transform="translate(-196.79 633.49) rotate(-68)"
					/>
					<path
						className="fi"
						d="M381.59,479.98l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="370.75" cy="462.6" r="7.8" />
				<g id="i" className="fk">
					<path
						className="fi"
						d="M370.07,463.39c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.26,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
					/>
					<path
						className="fi"
						d="M373.81,464.94c-.23,.58-.61,.95-1.12,1.11s-1.11,.1-1.8-.18c-.14-.06-.29-.13-.44-.23-.16-.1-.29-.2-.4-.31l.34-1.17c.12,.14,.25,.26,.41,.36,.15,.1,.31,.18,.48,.25,.12,.05,.24,.08,.36,.09,.12,.01,.24,0,.35-.03,.11-.03,.21-.09,.3-.16s.16-.18,.22-.31c.04-.1,.06-.2,.05-.31,0-.11-.03-.21-.08-.31-.05-.1-.11-.19-.2-.27-.08-.08-.18-.14-.29-.19-.07-.03-.16-.05-.27-.08l.29-1.03c.25,.04,.48,.03,.67-.03,.2-.06,.33-.17,.4-.34,.06-.14,.05-.28-.01-.41-.06-.13-.19-.24-.37-.31-.15-.06-.28-.1-.4-.12-.12-.02-.26-.02-.42,0l.32-1.07c.18,0,.36,0,.54,.04,.18,.03,.38,.09,.6,.18,.25,.1,.46,.23,.64,.37,.18,.15,.31,.31,.41,.49,.1,.18,.15,.36,.16,.56,0,.2-.02,.4-.1,.6-.11,.27-.27,.48-.48,.62-.21,.14-.42,.21-.62,.22,.11,.08,.22,.2,.31,.33,.09,.13,.17,.29,.22,.46,.05,.17,.07,.36,.07,.55,0,.2-.05,.4-.13,.61Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo52">
			<g>
				<g>
					<rect
						className="fs"
						x="330.24"
						y="435.48"
						width="23.4"
						height="31.3"
						transform="translate(-204.43 599.18) rotate(-68)"
					/>
					<path
						className="fi"
						d="M352.34,468.49l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="341.85" cy="450.9" r="7.8" />
				<g id="k" className="fk">
					<path
						className="fi"
						d="M341.08,451.68c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.27,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
					/>
					<path
						className="fi"
						d="M340.9,453.62l.14-.34c.4-.17,.79-.36,1.18-.57,.39-.21,.74-.42,1.07-.63,.32-.22,.6-.43,.83-.65,.23-.22,.39-.43,.47-.63,.11-.28,.12-.52,.03-.73-.1-.21-.26-.36-.51-.46-.21-.08-.42-.13-.62-.14-.2-.01-.41,0-.62,.04l.35-1.16c.22-.03,.45-.04,.7-.01s.51,.09,.77,.2c.28,.12,.53,.26,.74,.44s.38,.38,.49,.61c.12,.23,.18,.48,.18,.75,0,.27-.06,.56-.18,.87-.09,.23-.23,.45-.43,.67-.2,.22-.41,.42-.65,.61-.24,.19-.49,.36-.75,.52-.26,.15-.5,.28-.71,.38l1.71,.69-.43,1.06-3.76-1.52Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo51">
			<g>
				<g>
					<rect
						className="fs"
						x="298.14"
						y="418.47"
						width="23.4"
						height="39.1"
						transform="translate(-212.36 561.22) rotate(-68)"
					/>
					<path
						className="fi"
						d="M323.86,456.85l-37.18-15.02,9.14-22.62,37.18,15.02-9.14,22.62Zm-35.88-15.57l35.33,14.27,8.39-20.77-35.33-14.27-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="309.15" cy="437.6" r="7.8" />
				<g id="m" className="fk">
					<path
						className="fi"
						d="M309.09,438.76c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.26,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
					/>
					<path
						className="fi"
						d="M309.79,441.05l1.8-4.45-1.02-.31,.54-1.07,2.23,.68-2.29,5.66-1.26-.51Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo50">
			<g id="o">
				<g>
					<g>
						<rect
							className="fs"
							x="192.11"
							y="374.88"
							width="23.4"
							height="39.1"
							transform="translate(-238.25 435.64) rotate(-68)"
						/>
						<path
							className="fi"
							d="M217.83,413.25l-37.18-15.02,9.14-22.62,37.18,15.02-9.14,22.62Zm-35.88-15.57l35.33,14.27,8.39-20.77-35.33-14.27-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="204.95" cy="395.1" r="7.8" />
					<g id="p" className="fk">
						<path
							className="fi"
							d="M203.93,395.54c-.11,.28-.26,.51-.44,.7s-.4,.33-.64,.42c-.25,.09-.52,.12-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3-.17-.11-.3-.22-.39-.31l.35-1.18c.13,.15,.27,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69s-.31-.38-.58-.49c-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.08,.03c.03,.01,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38,.17,.17,.3,.36,.4,.58s.15,.46,.16,.72c0,.26-.04,.51-.15,.78Z"
						/>
						<path
							className="fi"
							d="M209.19,396.45c-.21,.51-.44,.93-.71,1.25s-.54,.56-.84,.71c-.29,.16-.59,.24-.89,.25s-.59-.04-.87-.16c-.28-.11-.53-.28-.74-.5-.21-.22-.36-.48-.46-.79s-.13-.68-.1-1.09c.03-.42,.15-.88,.36-1.39,.2-.5,.44-.92,.7-1.24,.26-.32,.54-.55,.83-.71,.29-.16,.58-.24,.89-.25,.3,0,.59,.04,.88,.16,.28,.11,.52,.28,.74,.49s.37,.48,.47,.8c.1,.31,.14,.68,.11,1.09-.03,.41-.15,.87-.35,1.38Zm-1.26-.51c.25-.61,.34-1.1,.29-1.46-.05-.37-.2-.6-.43-.69-.23-.09-.49-.03-.78,.2-.29,.23-.56,.64-.81,1.25-.12,.31-.21,.58-.25,.83-.05,.25-.06,.46-.04,.64,.02,.18,.07,.33,.14,.44,.07,.11,.17,.19,.29,.24,.23,.09,.5,.03,.79-.19,.29-.22,.56-.64,.81-1.26Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo49">
			<g>
				<g>
					<rect
						className="fs"
						x="217.1"
						y="267.78"
						width="23.4"
						height="31.3"
						transform="translate(-119.7 389.4) rotate(-68)"
					/>
					<path
						className="fi"
						d="M239.21,300.79l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
					/>
				</g>
				<circle className="ff" cx="228.85" cy="283.2" r="7.8" />
				<g id="r" className="fk">
					<path
						className="fi"
						d="M227.49,284.26l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
					/>
					<path
						className="fi"
						d="M233.54,284.08c-.15,.38-.36,.72-.63,1.04-.27,.32-.57,.6-.91,.84-.34,.25-.71,.45-1.11,.62-.4,.17-.81,.28-1.22,.34l-1.12-.92c.25-.02,.51-.06,.77-.12,.26-.06,.51-.14,.75-.23,.24-.09,.47-.2,.68-.33,.21-.12,.39-.25,.55-.39-.16,.05-.33,.04-.53-.04-.22-.09-.42-.22-.61-.39-.19-.17-.34-.37-.45-.61-.11-.23-.18-.48-.2-.76-.02-.27,.03-.56,.15-.85,.11-.28,.26-.52,.46-.71s.41-.34,.66-.44c.24-.1,.51-.14,.78-.14,.28,0,.56,.06,.83,.18,.27,.11,.51,.26,.72,.45,.21,.19,.36,.41,.47,.67,.11,.25,.16,.53,.17,.83s-.07,.62-.2,.95Zm-1.2-.66c.05-.12,.07-.24,.07-.36,0-.12-.02-.22-.07-.33-.04-.1-.1-.19-.17-.27-.08-.08-.17-.14-.27-.18-.19-.08-.38-.07-.58,.01-.19,.09-.33,.24-.42,.46-.09,.23-.1,.45-.02,.65,.08,.2,.23,.35,.45,.44,.16,.06,.31,.09,.46,.07,.15-.01,.28-.08,.4-.2,.03-.04,.06-.09,.08-.15,.03-.06,.05-.11,.07-.16Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo48">
			<g id="t">
				<g>
					<g>
						<rect
							className="fs"
							x="249.43"
							y="277.05"
							width="23.4"
							height="39.1"
							transform="translate(-111.69 427.62) rotate(-68)"
						/>
						<path
							className="fi"
							d="M275.15,315.42l-37.18-15.02,9.14-22.62,37.18,15.02-9.14,22.62Zm-35.88-15.57l35.33,14.27,8.39-20.77-35.33-14.27-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="262.35" cy="297.2" r="7.8" />
					<g id="u" className="fk">
						<path
							className="fi"
							d="M260.91,297.98l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.41,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M266.23,299.82c-.11,.27-.25,.49-.44,.66-.19,.17-.4,.3-.63,.38-.24,.08-.49,.11-.77,.09-.28-.02-.57-.09-.86-.21-.29-.12-.55-.27-.76-.45-.21-.18-.38-.38-.5-.6-.12-.22-.18-.46-.19-.71-.01-.25,.04-.52,.14-.78,.07-.18,.17-.33,.29-.46,.12-.13,.25-.23,.4-.32,.14-.08,.28-.14,.42-.18,.14-.04,.26-.06,.36-.06-.08-.08-.14-.17-.19-.29-.05-.11-.09-.24-.11-.37-.03-.13-.03-.27-.02-.41,0-.14,.04-.28,.1-.41,.09-.22,.21-.41,.38-.56,.16-.15,.35-.26,.56-.33,.21-.07,.44-.1,.69-.08,.25,.02,.51,.08,.78,.19s.5,.24,.69,.41c.19,.16,.34,.34,.45,.54,.1,.2,.16,.41,.17,.63,0,.22-.03,.45-.12,.68-.05,.13-.12,.24-.21,.34-.09,.1-.19,.19-.3,.26-.11,.07-.22,.13-.34,.17-.12,.04-.22,.07-.33,.08,.08,.08,.15,.18,.23,.31,.08,.13,.14,.27,.18,.43,.04,.16,.07,.33,.06,.51,0,.18-.04,.36-.11,.54Zm-1.24-.51c.04-.1,.06-.21,.04-.32-.02-.11-.05-.21-.11-.31-.05-.1-.12-.19-.2-.28-.08-.09-.16-.16-.24-.22-.1-.01-.2-.01-.31,0-.11,0-.21,.03-.31,.07-.1,.04-.19,.09-.28,.16-.08,.07-.15,.15-.19,.26-.04,.1-.06,.21-.05,.31,0,.1,.04,.2,.09,.3,.05,.09,.12,.18,.2,.25,.08,.07,.17,.13,.28,.17,.11,.04,.22,.07,.33,.07,.11,0,.21-.01,.31-.04,.1-.03,.19-.09,.27-.16s.14-.16,.18-.26Zm.9-2.54c.07-.17,.06-.33-.02-.49-.08-.16-.22-.28-.4-.35-.18-.07-.35-.08-.52-.02-.17,.06-.29,.17-.35,.34-.06,.15-.05,.31,.02,.48,.08,.17,.21,.32,.39,.46,.23,.02,.42,0,.57-.07,.15-.07,.26-.18,.32-.34Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo47">
			<g id="w">
				<g>
					<g>
						<rect
							className="fs"
							x="281.83"
							y="294.23"
							width="23.4"
							height="31.3"
							transform="translate(-103.74 465.96) rotate(-68)"
						/>
						<path
							className="fi"
							d="M303.94,327.24l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="293.45" cy="309.8" r="7.8" />
					<g id="x" className="fk">
						<path
							className="fi"
							d="M292.26,310.64l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.41,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M294.58,313.13l-1.32-.53,3.7-3.73-2.3-.93,.43-1.06,4.02,1.62-4.52,4.63Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo46">
			<g id="a`">
				<g>
					<g>
						<rect
							className="fs"
							x="311.09"
							y="305.83"
							width="23.4"
							height="31.3"
							transform="translate(-96.2 500.34) rotate(-68)"
						/>
						<path
							className="fi"
							d="M333.2,338.84l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="323.15" cy="321.8" r="7.8" />
					<g id="aa" className="fk">
						<path
							className="fi"
							d="M321.75,322.55l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M327.09,324.19c-.11,.28-.27,.51-.46,.71-.19,.2-.41,.34-.66,.44s-.51,.14-.78,.14c-.28,0-.56-.06-.83-.18-.27-.11-.51-.26-.72-.45s-.36-.41-.47-.67c-.11-.25-.17-.53-.17-.83,0-.3,.07-.62,.2-.95,.15-.37,.36-.72,.62-1.04,.26-.32,.57-.6,.91-.85s.71-.45,1.11-.61,.81-.28,1.24-.34l1.13,.92c-.25,.02-.51,.06-.77,.12-.26,.06-.51,.14-.75,.23-.24,.1-.47,.21-.68,.33s-.39,.25-.55,.38c.16-.05,.33-.04,.53,.04,.22,.09,.42,.22,.61,.39,.19,.17,.34,.38,.45,.61,.11,.23,.18,.48,.2,.76s-.03,.55-.15,.84Zm-1.25-.47c.09-.23,.1-.45,.02-.66-.08-.21-.23-.35-.45-.44-.15-.06-.3-.08-.45-.07-.15,.01-.28,.08-.4,.2-.03,.04-.06,.09-.08,.15-.03,.06-.05,.11-.07,.16-.1,.24-.1,.47,0,.68,.09,.21,.24,.36,.44,.44,.2,.08,.39,.08,.59-.01,.19-.09,.33-.24,.42-.46Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo45">
			<g id="ac">
				<g>
					<g>
						<rect
							className="fs"
							x="340.04"
							y="317.71"
							width="23.4"
							height="31.3"
							transform="translate(-89.11 534.61) rotate(-68)"
						/>
						<path
							className="fi"
							d="M362.14,350.72l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="351.55" cy="333.3" r="7.8" />
					<g id="ad" className="fk">
						<path
							className="fi"
							d="M350.46,334.15l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M355.16,335.59c-.11,.28-.26,.51-.44,.7-.18,.19-.4,.33-.64,.42-.25,.09-.52,.13-.82,.11-.3-.02-.62-.09-.96-.23-.21-.09-.41-.19-.58-.3s-.3-.22-.39-.31l.35-1.18c.13,.15,.27,.28,.42,.39,.15,.1,.32,.2,.52,.28,.26,.11,.51,.12,.74,.06,.23-.07,.39-.22,.48-.44,.1-.24,.09-.48-.03-.69-.12-.22-.31-.38-.58-.49-.19-.08-.35-.13-.49-.16-.13-.03-.28-.04-.43-.05l1.35-3.13,2.62,1.06-.52,1.02-1.3-.53-.44,.98s.06,.01,.09,.03c.03,0,.05,.02,.08,.03,.21,.09,.41,.21,.57,.38s.3,.36,.4,.58c.1,.22,.15,.46,.16,.72,0,.26-.04,.51-.15,.78Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo44">
			<g id="af">
				<g>
					<g>
						<rect
							className="fs"
							x="369.11"
							y="329.17"
							width="23.4"
							height="31.3"
							transform="translate(-81.55 568.74) rotate(-68)"
						/>
						<path
							className="fi"
							d="M391.22,362.18l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="380.65" cy="345" r="7.8" />
					<g id="ag" className="fk">
						<path
							className="fi"
							d="M379.27,345.86l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M383.79,347.69l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.96-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.79,1.22,.49,.46-1.13c.07-.19,.16-.37,.25-.56v-.02Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo43">
			<g id="ai">
				<g>
					<g>
						<rect
							className="fs"
							x="422.66"
							y="351.15"
							width="23.4"
							height="31.3"
							transform="translate(-68.44 632.13) rotate(-68)"
						/>
						<path
							className="fi"
							d="M444.77,384.16l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="433.85" cy="366.7" r="7.8" />
					<g id="aj" className="fk">
						<path
							className="fi"
							d="M432.97,367.61l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M437.48,369.02c-.23,.58-.61,.95-1.12,1.11s-1.12,.1-1.8-.18c-.14-.06-.29-.13-.44-.23s-.29-.2-.4-.31l.34-1.17c.12,.14,.25,.26,.41,.36,.15,.1,.31,.18,.48,.25,.12,.05,.24,.08,.36,.09,.12,.01,.24,0,.35-.03s.21-.09,.3-.16c.09-.08,.16-.18,.22-.31,.04-.1,.06-.2,.05-.31s-.03-.21-.08-.31c-.05-.1-.11-.19-.2-.27-.08-.08-.18-.14-.29-.19-.07-.03-.16-.05-.27-.08l.29-1.03c.25,.04,.48,.03,.67-.03s.33-.17,.4-.34c.06-.14,.05-.28-.01-.41-.06-.13-.19-.24-.37-.31-.14-.06-.28-.1-.4-.12-.12-.02-.26-.02-.42,0l.32-1.07c.18,0,.36,0,.54,.03,.18,.03,.38,.09,.6,.18,.25,.1,.46,.22,.64,.37,.18,.15,.31,.31,.41,.49,.1,.18,.15,.37,.16,.56,.01,.2-.02,.4-.1,.6-.11,.27-.27,.48-.48,.62-.21,.14-.42,.21-.62,.22,.11,.09,.22,.2,.31,.33,.09,.14,.17,.29,.22,.46,.05,.17,.07,.36,.07,.55,0,.2-.05,.4-.13,.61Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo42">
			<g id="al">
				<g>
					<g>
						<rect
							className="fs"
							x="451.67"
							y="362.55"
							width="23.4"
							height="31.3"
							transform="translate(-60.87 666.16) rotate(-68)"
						/>
						<path
							className="fi"
							d="M473.78,395.57l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="463.05" cy="378.6" r="7.8" />
					<g id="am" className="fk">
						<path
							className="fi"
							d="M461.84,379.28l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M462.42,381.07l.14-.34c.4-.17,.79-.37,1.18-.57,.39-.21,.74-.42,1.07-.63,.32-.22,.6-.43,.83-.65s.38-.43,.47-.63c.11-.28,.12-.52,.03-.73-.1-.21-.26-.36-.51-.46-.21-.08-.42-.13-.62-.14-.2-.01-.41,0-.62,.04l.35-1.16c.22-.03,.45-.04,.7-.01,.25,.03,.51,.09,.77,.2,.28,.11,.53,.26,.74,.44,.21,.18,.38,.38,.49,.61,.12,.23,.18,.48,.18,.75,0,.27-.05,.56-.18,.87-.09,.23-.23,.45-.43,.67-.2,.22-.41,.42-.65,.61-.24,.19-.49,.36-.75,.52s-.5,.28-.71,.38l1.71,.69-.43,1.06-3.76-1.52Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo41">
			<g id="ao">
				<g>
					<g>
						<rect
							className="fs"
							x="503.27"
							y="383.67"
							width="23.4"
							height="31.3"
							transform="translate(-48.18 727.21) rotate(-68)"
						/>
						<path
							className="fi"
							d="M525.38,416.68l-29.95-12.1,9.14-22.62,29.95,12.1-9.14,22.62Zm-28.65-12.65l28.09,11.35,8.39-20.77-28.09-11.35-8.39,20.77Z"
						/>
					</g>
					<circle className="ff" cx="514.45" cy="399.5" r="7.8" />
					<g id="ap" className="fk">
						<path
							className="fi"
							d="M513.92,400.55l-.54,1.34-1.18-.48,.54-1.34-2.21-.89,.24-1.07,3.69-2.24,1.17,.47-1.31,3.24,.59,.24-.39,.97-.59-.24Zm-.1-3.14c-.2,.15-.4,.29-.63,.42l-1.29,.78,1.22,.49,.46-1.13c.08-.19,.16-.37,.25-.56h-.01Z"
						/>
						<path
							className="fi"
							d="M515.38,402.7l1.8-4.45-1.02-.31,.54-1.07,2.23,.68-2.29,5.66-1.26-.51Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo40">
			<g id="ar">
				<g>
					<g>
						<rect
							className="fs"
							x="584.45"
							y="299.3"
							width="28.1"
							height="75"
						/>
						<path
							className="fi"
							d="M613.05,374.8h-29.1v-76h29.1v76Zm-28.1-1h27.1v-74h-27.1v74Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="598.35" cy="336.8" r="7.8" />
						<g id="as" className="fk">
							<path
								className="fi"
								d="M597.25,338.09v1.44h-1.28v-1.44h-2.38l-.18-1.08,2.58-3.46h1.26v3.5h.64v1.04h-.64Zm-1.27-2.88c-.13,.21-.27,.42-.42,.63l-.9,1.21h1.31v-1.22c0-.2,0-.4,.03-.61h-.02Z"
							/>
							<path
								className="fi"
								d="M603.12,336.53c0,.55-.06,1.02-.19,1.42-.12,.4-.29,.72-.51,.98-.21,.25-.46,.44-.74,.56-.28,.12-.57,.18-.87,.18s-.6-.06-.87-.18-.52-.31-.73-.56c-.21-.25-.38-.58-.5-.98-.12-.4-.19-.87-.19-1.42s.06-1.01,.19-1.41c.12-.39,.29-.72,.5-.97,.21-.25,.45-.44,.73-.56s.57-.18,.87-.18,.59,.06,.87,.18c.28,.12,.52,.31,.74,.56,.21,.25,.38,.58,.51,.97,.12,.39,.19,.86,.19,1.41Zm-1.36,0c0-.66-.09-1.14-.28-1.46-.19-.32-.41-.48-.66-.48s-.46,.16-.65,.48c-.19,.32-.28,.81-.28,1.46,0,.33,.03,.62,.08,.87s.12,.45,.2,.61c.08,.16,.18,.28,.29,.36s.23,.12,.36,.12c.25,0,.47-.16,.66-.47,.19-.32,.28-.81,.28-1.48Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo39">
			<g id="au">
				<g>
					<g>
						<rect
							className="fs"
							x="584.45"
							y="247.9"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M613.05,285.9h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="598.45" cy="266.6" r="7.8" />
					<g id="av" className="fk">
						<path
							className="fi"
							d="M597.74,267.67c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
						/>
						<path
							className="fi"
							d="M602.62,265.63c0,.41-.06,.81-.19,1.2-.13,.39-.31,.77-.53,1.12-.23,.36-.49,.69-.8,.99-.31,.3-.65,.56-1.01,.77l-1.39-.43c.23-.11,.45-.25,.67-.4s.42-.32,.61-.5,.36-.36,.51-.56c.15-.19,.27-.38,.37-.56-.12,.11-.29,.16-.51,.16-.24,0-.48-.05-.71-.14-.24-.09-.45-.22-.64-.39s-.35-.38-.46-.63c-.12-.25-.18-.53-.18-.84s.05-.58,.16-.83,.25-.47,.45-.65c.19-.18,.42-.32,.67-.42,.26-.1,.54-.15,.84-.15s.57,.05,.83,.15c.26,.1,.49,.25,.69,.44s.35,.43,.46,.71c.11,.28,.17,.6,.17,.95Zm-1.36-.16c0-.13-.02-.25-.07-.36-.05-.11-.11-.2-.18-.28-.08-.08-.16-.14-.26-.18-.1-.04-.21-.07-.32-.07-.21,0-.38,.08-.53,.23-.15,.15-.22,.35-.22,.59,0,.25,.08,.46,.22,.61,.15,.16,.34,.24,.58,.24,.17,0,.32-.03,.46-.1,.13-.07,.23-.18,.29-.34,.01-.05,.02-.11,.02-.17s0-.12,0-.18Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo38">
			<g>
				<g>
					<rect
						className="fs"
						x="664.95"
						y="246.2"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M693.55,284.2h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="678.95" cy="265.1" r="7.8" />
				<g id="ax" className="fk">
					<path
						className="fi"
						d="M678.16,266c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M683.12,266.1c0,.29-.05,.55-.16,.78s-.25,.43-.45,.59c-.19,.16-.42,.28-.68,.37-.27,.09-.56,.13-.88,.13s-.61-.04-.88-.13c-.27-.09-.49-.21-.68-.37-.19-.16-.34-.35-.45-.59-.11-.23-.16-.49-.16-.78,0-.19,.03-.37,.1-.54,.07-.17,.15-.31,.25-.44,.1-.13,.21-.24,.32-.32,.12-.09,.22-.15,.31-.19-.1-.04-.2-.11-.29-.2-.09-.09-.17-.19-.24-.3s-.13-.24-.17-.37c-.04-.13-.07-.27-.07-.42,0-.24,.05-.46,.14-.66s.23-.37,.39-.52,.37-.25,.61-.33,.5-.12,.79-.12,.55,.04,.79,.12,.45,.19,.62,.34c.17,.15,.3,.32,.4,.52,.09,.2,.14,.43,.14,.67,0,.14-.02,.27-.07,.4-.04,.13-.1,.25-.18,.35-.07,.11-.16,.2-.25,.29-.09,.08-.18,.15-.28,.19,.1,.04,.21,.11,.33,.2,.12,.09,.23,.2,.33,.33,.1,.13,.18,.28,.25,.45,.07,.17,.1,.35,.1,.54Zm-1.34,0c0-.11-.03-.22-.08-.31-.06-.09-.13-.18-.21-.25-.09-.07-.18-.13-.29-.18-.11-.05-.21-.09-.31-.11-.09,.03-.19,.06-.29,.11-.1,.05-.18,.11-.26,.18s-.14,.15-.2,.25c-.05,.09-.08,.2-.08,.31s.02,.22,.07,.31,.11,.18,.19,.24c.08,.07,.17,.12,.28,.16,.1,.04,.21,.06,.32,.06,.12,0,.23-.02,.33-.06,.1-.04,.19-.09,.27-.16s.14-.15,.19-.24,.07-.2,.07-.31Zm-.11-2.69c0-.18-.07-.33-.21-.45-.14-.12-.31-.18-.51-.18s-.36,.06-.49,.18c-.13,.12-.2,.27-.2,.45,0,.16,.07,.31,.2,.44,.13,.13,.31,.22,.53,.28,.22-.06,.39-.16,.5-.28,.12-.12,.17-.27,.17-.43Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo37">
			<g>
				<g>
					<rect
						className="fs"
						x="664.95"
						y="283.7"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M693.55,321.7h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="678.85" cy="302.6" r="7.8" />
				<g id="b`" className="fk">
					<path
						className="fi"
						d="M678.26,303.51c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M680.69,305.34h-1.42l2.03-4.84h-2.48v-1.14h4.33l-2.46,5.98Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo36">
			<g>
				<g>
					<rect className="fs" x="693.05" y="246.2" width="28.1" height="75" />
					<path
						className="fi"
						d="M721.65,321.7h-29.1v-76h29.1v76Zm-28.1-1h27.1v-74h-27.1v74Z"
					/>
				</g>
				<circle className="ff" cx="706.75" cy="282.9" r="7.8" />
				<g id="bb" className="fk">
					<path
						className="fi"
						d="M706,283.77c0,.62-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05-.18-.03-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.03,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.3-.04-.1-.11-.18-.19-.25-.08-.07-.17-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.45-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.06-.27-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04s-.25,.08-.39,.15l-.1-1.1c.16-.08,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11s.41,.17,.56,.3c.16,.13,.28,.28,.36,.46,.08,.18,.13,.38,.13,.59,0,.29-.07,.54-.22,.75s-.31,.35-.49,.44c.14,.04,.27,.1,.41,.19s.26,.21,.38,.35c.11,.14,.2,.3,.27,.49,.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M710.91,283.68c0,.3-.05,.58-.16,.83s-.25,.47-.45,.65c-.19,.18-.42,.32-.67,.42-.26,.1-.54,.15-.84,.15s-.57-.05-.83-.15c-.26-.1-.49-.25-.69-.44-.2-.19-.35-.43-.46-.71-.11-.28-.17-.59-.17-.95,0-.4,.06-.8,.19-1.19,.12-.4,.3-.77,.53-1.13,.23-.36,.49-.68,.8-.98s.65-.56,1.02-.78l1.39,.43c-.23,.11-.45,.25-.67,.4-.22,.15-.42,.32-.61,.5-.19,.18-.36,.36-.51,.56-.15,.19-.27,.38-.37,.56,.12-.11,.29-.16,.51-.16,.24,0,.47,.05,.71,.14,.24,.09,.45,.22,.64,.39,.19,.17,.34,.38,.46,.63,.12,.25,.18,.53,.18,.84Zm-1.33,.03c0-.25-.08-.45-.23-.61s-.35-.24-.59-.24c-.16,0-.31,.03-.45,.1s-.23,.18-.29,.34c-.01,.05-.02,.11-.02,.17,0,.06,0,.12,0,.18,0,.26,.08,.47,.25,.64,.17,.16,.36,.24,.58,.24s.39-.08,.54-.23,.22-.35,.22-.58Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo35">
			<g>
				<g>
					<rect
						className="fs"
						x="755.05"
						y="246.2"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M783.65,284.2h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="768.85" cy="265.1" r="7.8" />
				<g id="bd" className="fk">
					<path
						className="fi"
						d="M768.48,266c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M772.73,265.96c0,.3-.05,.57-.15,.82-.1,.24-.25,.45-.44,.63-.19,.17-.43,.31-.72,.41-.29,.1-.61,.14-.98,.14-.23,0-.45-.02-.65-.06s-.36-.09-.48-.15l-.12-1.23c.17,.09,.35,.16,.53,.2,.18,.04,.37,.06,.59,.06,.28,0,.52-.08,.7-.22,.19-.15,.28-.35,.28-.59,0-.26-.1-.47-.29-.63-.19-.16-.43-.24-.72-.24-.21,0-.38,.01-.51,.04-.13,.02-.27,.06-.42,.11l.08-3.4h2.82l-.1,1.14h-1.41l-.04,1.07s.06,0,.09,0h.09c.23,0,.46,.05,.67,.14s.41,.22,.59,.39,.31,.37,.41,.61,.15,.49,.15,.77Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo34">
			<g>
				<g>
					<rect
						className="fs"
						x="755.05"
						y="283.7"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M783.65,321.7h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="769.05" cy="302.6" r="7.8" />
				<g id="bf" className="fk">
					<path
						className="fi"
						d="M768.33,303.51c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M772.55,303.9v1.44h-1.28v-1.44h-2.38l-.18-1.08,2.58-3.46h1.26v3.5h.64v1.04h-.64Zm-1.27-2.88c-.12,.21-.27,.42-.42,.63l-.9,1.21h1.31v-1.22c0-.2,0-.4,.03-.61h-.02Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo33">
			<g>
				<g>
					<rect
						className="fs"
						x="783.25"
						y="283.7"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M811.85,321.7h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="796.95" cy="302.6" r="7.8" />
				<g id="bh" className="fk">
					<path
						className="fi"
						d="M796.67,303.51c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M800.72,303.51c0,.63-.21,1.11-.62,1.45s-1,.51-1.74,.51c-.15,0-.32-.02-.5-.05-.18-.03-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16s.16-.16,.22-.26,.08-.23,.08-.37c0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.17-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46,.08,.18,.13,.38,.13,.59,0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.27,.1,.41,.19,.14,.09,.26,.21,.38,.35,.11,.14,.2,.3,.27,.49s.1,.39,.1,.61Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo32">
			<g>
				<g>
					<rect
						className="fs"
						x="783.25"
						y="246.2"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M811.85,284.2h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="797.15" cy="265.1" r="7.8" />
				<g id="bj" className="fk">
					<path
						className="fi"
						d="M796.54,266c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M797.1,267.83v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99,.22-.32,.39-.62,.52-.91,.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.23,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63s.16,.54,.16,.87c0,.24-.05,.5-.15,.78-.1,.28-.23,.55-.38,.81-.15,.27-.32,.52-.5,.76-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
					/>
				</g>
			</g>
		</g>
		<g id="lounge">
			<g>
				<rect className="fq" x="864.05" y="321" width="28.1" height="56.3" />
				<path
					className="fp"
					d="M892.65,377.8h-29.1v-57.3h29.1v57.3Zm-28.1-1h27.1v-55.3h-27.1v55.3Z"
				/>
			</g>
			<g className="fk">
				<path
					className="ff"
					d="M880.88,366.26h-5.98v-1.45h4.74v-2.4h1.25v3.85Z"
				/>
				<path
					className="ff"
					d="M877.88,355.55c.48,0,.92,.09,1.3,.27,.39,.18,.72,.42,.99,.72,.27,.3,.48,.64,.63,1.03,.15,.39,.22,.79,.22,1.2s-.07,.81-.22,1.2c-.15,.39-.36,.73-.63,1.03-.27,.3-.6,.54-.99,.72s-.82,.27-1.3,.27-.91-.09-1.29-.27-.72-.42-.99-.72c-.27-.3-.48-.64-.62-1.03-.15-.39-.22-.79-.22-1.2s.07-.81,.22-1.2c.15-.39,.35-.73,.62-1.03,.27-.3,.6-.54,.99-.72,.39-.18,.82-.27,1.29-.27Zm0,1.47c-.28,0-.54,.05-.76,.15-.23,.1-.42,.23-.58,.39-.16,.17-.29,.35-.38,.56-.09,.21-.13,.43-.13,.65s.04,.44,.13,.65c.09,.21,.21,.4,.38,.56,.16,.16,.36,.29,.58,.39,.22,.1,.48,.15,.76,.15s.54-.05,.76-.15c.23-.1,.42-.23,.59-.39s.29-.35,.38-.56,.13-.43,.13-.65-.04-.44-.13-.65-.21-.4-.38-.56c-.16-.17-.36-.3-.59-.39-.23-.1-.48-.15-.76-.15Z"
				/>
				<path
					className="ff"
					d="M879.74,349.73c.27,.14,.5,.32,.68,.56,.19,.23,.33,.51,.44,.83,.1,.32,.15,.65,.15,1.01s-.05,.69-.15,1.01c-.1,.32-.25,.59-.44,.83-.19,.23-.42,.42-.68,.55s-.57,.2-.9,.2h-3.94v-1.45h3.81c.31,0,.55-.1,.75-.31,.19-.21,.29-.49,.29-.84s-.09-.63-.29-.84c-.19-.21-.44-.32-.75-.32h-3.81v-1.42h3.94c.33,0,.63,.07,.9,.21Z"
				/>
				<path
					className="ff"
					d="M880.95,343.6l-2.55,2.33c-.21,.19-.43,.38-.66,.58-.23,.2-.45,.38-.65,.54v.02c.22-.01,.44-.02,.66-.02,.22,0,.42,0,.61,0h2.53v1.45h-5.98v-1.17l2.23-2.03c.16-.14,.34-.31,.56-.49,.22-.18,.41-.35,.59-.48v-.02c-.37,.02-.74,.03-1.12,.03h-2.25v-1.45h6.05v.73Z"
				/>
				<path
					className="ff"
					d="M881.02,338.71c0,.41-.07,.82-.2,1.21-.13,.4-.33,.75-.6,1.06s-.59,.56-.98,.75-.84,.29-1.36,.29-.96-.1-1.35-.29c-.39-.19-.72-.45-.98-.76-.26-.31-.46-.66-.6-1.06-.13-.39-.2-.78-.2-1.18,0-.42,.04-.79,.14-1.11,.09-.32,.21-.59,.34-.79l1.28,.11c-.15,.21-.27,.45-.36,.73-.09,.28-.14,.58-.14,.91,0,.27,.04,.53,.13,.77,.09,.24,.21,.45,.38,.63,.17,.18,.37,.32,.61,.43,.24,.11,.5,.16,.8,.16s.54-.05,.76-.15c.23-.1,.42-.24,.59-.41,.16-.17,.29-.38,.38-.61,.09-.23,.13-.49,.13-.76,0-.34-.06-.61-.18-.81h-.84v1.09h-1.12v-2.42h2.76c.41,.52,.62,1.26,.62,2.21Z"
				/>
				<path
					className="ff"
					d="M880.88,335.53h-5.98v-3.49h1.19v2.03h1.19v-1.66h1.21v1.66h1.2v-2.3h1.19v3.75Z"
				/>
			</g>
		</g>
		<g id="demo31">
			<g>
				<g>
					<rect
						className="fs"
						x="864.25"
						y="246.2"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M892.85,284.2h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="877.75" cy="265.1" r="7.8" />
				<g id="bm" className="fk">
					<path
						className="fi"
						d="M877.89,266c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M879.4,267.83v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo30">
			<g>
				<g>
					<rect
						className="fs"
						x="864.25"
						y="283.7"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M892.85,321.7h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<circle className="ff" cx="878.25" cy="302.6" r="7.8" />
				<g id="bo" className="fk">
					<path
						className="fi"
						d="M877.39,303.51c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
					/>
					<path
						className="fi"
						d="M882.6,302.34c0,.55-.06,1.02-.19,1.42-.12,.4-.29,.72-.51,.98-.21,.25-.46,.44-.74,.56s-.57,.18-.87,.18-.6-.06-.87-.18c-.28-.12-.52-.31-.73-.56-.21-.25-.38-.58-.5-.98-.12-.4-.19-.87-.19-1.42s.06-1.01,.19-1.41c.12-.39,.29-.72,.5-.97,.21-.25,.45-.44,.73-.56,.27-.12,.57-.18,.87-.18s.59,.06,.87,.18,.52,.31,.74,.56c.21,.25,.38,.58,.51,.97,.12,.39,.19,.86,.19,1.41Zm-1.36,0c0-.66-.09-1.14-.28-1.46-.19-.32-.41-.48-.66-.48s-.46,.16-.65,.48c-.19,.32-.28,.81-.28,1.46,0,.33,.03,.62,.08,.87,.05,.25,.12,.45,.2,.61,.08,.16,.18,.28,.29,.36s.23,.12,.36,.12c.25,0,.47-.16,.66-.47,.19-.32,.28-.81,.28-1.48Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo29">
			<g id="bq">
				<g>
					<g>
						<rect
							className="fs"
							x="790.45"
							y="625.4"
							width="28.1"
							height="75"
						/>
						<path
							className="fi"
							d="M819.05,700.9h-29.1v-76h29.1v76Zm-28.1-1h27.1v-74h-27.1v74Z"
						/>
					</g>
					<circle className="ff" cx="804.35" cy="662.1" r="7.8" />
					<g id="br" className="fk">
						<path
							className="fi"
							d="M799.91,664.88v-.36c.31-.31,.6-.63,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.23,0-.44,.03-.63,.1s-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13s.49,.21,.68,.38c.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.27-.23,.54-.38,.81-.15,.27-.32,.52-.5,.76-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M808.79,661.01c0,.41-.06,.8-.19,1.2-.13,.39-.3,.77-.53,1.12-.23,.36-.49,.68-.8,.99s-.65,.56-1.01,.77l-1.39-.43c.22-.11,.45-.25,.67-.4,.22-.15,.42-.32,.61-.5s.36-.36,.51-.56c.15-.19,.27-.38,.37-.56-.12,.11-.29,.16-.51,.16-.24,0-.48-.04-.71-.14-.24-.09-.45-.22-.64-.39-.19-.17-.35-.38-.46-.63-.12-.25-.18-.53-.18-.84s.05-.58,.16-.83c.11-.25,.25-.47,.45-.65,.19-.18,.42-.32,.68-.42,.26-.1,.54-.15,.84-.15s.57,.05,.83,.15,.49,.25,.69,.44,.35,.43,.46,.71c.11,.28,.17,.59,.17,.95Zm-1.36-.16c0-.13-.02-.25-.07-.36s-.11-.2-.18-.28c-.07-.08-.16-.14-.26-.18-.1-.04-.21-.07-.32-.07-.21,0-.38,.08-.53,.23-.15,.15-.22,.35-.22,.58,0,.25,.08,.45,.22,.61,.15,.16,.34,.24,.58,.24,.17,0,.32-.03,.45-.1,.13-.07,.23-.18,.3-.34,.01-.05,.02-.11,.02-.17s0-.12,0-.18Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo28">
			<g id="bt">
				<g>
					<g>
						<rect
							className="fs"
							x="790.45"
							y="550.3"
							width="28.1"
							height="75"
						/>
						<path
							className="fi"
							d="M819.05,625.8h-29.1v-76h29.1v76Zm-28.1-1h27.1v-74h-27.1v74Z"
						/>
					</g>
					<circle className="ff" cx="804.35" cy="587.1" r="7.8" />
					<g id="bu" className="fk">
						<path
							className="fi"
							d="M799.9,589.85v-.36c.31-.31,.6-.63,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.23,0-.44,.03-.63,.1s-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13s.49,.21,.68,.38c.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.27-.23,.54-.38,.81-.15,.27-.32,.52-.5,.76-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M808.86,588.13c0,.29-.05,.55-.16,.78s-.25,.43-.45,.58c-.19,.16-.42,.28-.68,.37-.27,.09-.56,.13-.88,.13s-.61-.04-.88-.13c-.27-.09-.49-.21-.68-.37-.19-.16-.34-.35-.45-.58s-.16-.49-.16-.78c0-.19,.03-.37,.1-.54,.07-.17,.15-.31,.25-.44,.1-.13,.21-.24,.32-.32,.12-.09,.22-.15,.31-.19-.1-.04-.2-.11-.29-.2-.09-.09-.17-.19-.24-.3-.07-.11-.13-.24-.17-.37-.04-.13-.07-.27-.07-.42,0-.24,.05-.46,.14-.66,.09-.2,.23-.37,.39-.51,.17-.14,.37-.25,.61-.33,.24-.08,.5-.12,.79-.12s.55,.04,.79,.12c.24,.08,.45,.19,.62,.34s.3,.32,.4,.52c.09,.2,.14,.43,.14,.67,0,.14-.02,.27-.07,.4s-.1,.25-.18,.35c-.08,.11-.16,.2-.25,.29-.09,.08-.18,.15-.28,.19,.1,.04,.21,.11,.33,.2,.12,.09,.23,.2,.33,.33,.1,.13,.18,.28,.25,.45,.07,.17,.1,.34,.1,.54Zm-1.34,0c0-.11-.03-.21-.08-.31-.06-.09-.13-.18-.22-.25-.09-.07-.18-.13-.29-.18s-.21-.09-.31-.11c-.09,.03-.19,.06-.29,.11s-.18,.11-.26,.18c-.08,.07-.14,.15-.2,.25-.05,.09-.08,.2-.08,.31s.02,.21,.07,.31,.11,.17,.19,.24c.08,.07,.17,.12,.28,.16,.1,.04,.21,.06,.32,.06,.12,0,.23-.02,.33-.06,.1-.04,.19-.09,.27-.16,.08-.07,.14-.15,.19-.24s.07-.2,.07-.31Zm-.11-2.69c0-.18-.07-.33-.21-.45-.14-.12-.31-.18-.51-.18s-.36,.06-.49,.18c-.13,.12-.2,.27-.2,.45,0,.16,.07,.31,.2,.44,.13,.13,.31,.22,.53,.28,.22-.06,.39-.16,.5-.28,.12-.12,.17-.27,.17-.43Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo27">
			<g id="bw">
				<g>
					<g>
						<rect
							className="fs"
							x="790.45"
							y="512.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M819.05,550.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="804.45" cy="531.7" r="7.8" />
					<g id="bx" className="fk">
						<path
							className="fi"
							d="M800.32,534.6v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M806.75,534.6h-1.42l2.03-4.84h-2.48v-1.14h4.33l-2.46,5.98Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo26">
			<g>
				<g>
					<rect className="fs" x="790.45" y="437.8" width="28.1" height="75" />
					<path
						className="fi"
						d="M819.05,513.3h-29.1v-76h29.1v76Zm-28.1-1h27.1v-74h-27.1v74Z"
					/>
				</g>
				<circle className="ff" cx="804.35" cy="474.5" r="7.8" />
				<g id="c`" className="fk">
					<path
						className="fi"
						d="M799.91,477.31v-.36c.31-.31,.6-.63,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.23,0-.44,.03-.63,.1s-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13s.49,.21,.68,.38c.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.27-.23,.54-.38,.81-.15,.27-.32,.52-.5,.76-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
					/>
					<path
						className="fi"
						d="M808.81,475.39c0,.3-.05,.58-.16,.83-.11,.25-.25,.47-.45,.65-.19,.18-.42,.32-.67,.42-.26,.1-.54,.15-.84,.15s-.57-.05-.83-.15-.49-.25-.69-.44c-.2-.19-.35-.43-.46-.71s-.17-.59-.17-.95c0-.4,.06-.8,.19-1.19s.3-.77,.53-1.13c.23-.36,.49-.68,.8-.98s.65-.56,1.02-.78l1.39,.43c-.23,.11-.45,.25-.67,.4-.22,.15-.42,.32-.61,.5s-.36,.36-.51,.56c-.15,.19-.27,.38-.37,.56,.12-.11,.29-.16,.51-.16,.24,0,.47,.04,.71,.14,.24,.09,.45,.22,.64,.39,.19,.17,.34,.38,.46,.63,.12,.25,.18,.53,.18,.84Zm-1.33,.03c0-.25-.08-.45-.23-.61s-.35-.24-.59-.24c-.16,0-.31,.03-.45,.1-.13,.07-.23,.18-.29,.34-.01,.05-.02,.11-.02,.17,0,.06,0,.12,0,.18,0,.26,.08,.47,.25,.64s.36,.24,.58,.24,.39-.08,.54-.23c.15-.15,.22-.35,.22-.58Z"
					/>
				</g>
			</g>
		</g>
		<g id="demo25">
			<g id="cb">
				<g>
					<g>
						<rect
							className="fs"
							x="790.45"
							y="400.3"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M819.05,438.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="804.45" cy="419.2" r="7.8" />
					<g id="cc" className="fk">
						<path
							className="fi"
							d="M800.31,422.06v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M808.55,420.19c0,.3-.05,.57-.15,.82-.1,.24-.25,.45-.44,.63-.19,.17-.43,.31-.72,.41-.29,.1-.61,.14-.98,.14-.23,0-.45-.02-.65-.06s-.36-.09-.48-.15l-.12-1.23c.17,.09,.35,.16,.53,.2,.18,.04,.37,.06,.59,.06,.28,0,.52-.08,.7-.22,.19-.15,.28-.35,.28-.59,0-.26-.1-.47-.29-.63-.19-.16-.43-.24-.72-.24-.21,0-.38,.01-.51,.04-.13,.02-.27,.06-.42,.11l.08-3.4h2.82l-.1,1.14h-1.41l-.04,1.07s.06,0,.09,0h.09c.23,0,.46,.05,.67,.14s.41,.22,.59,.39,.31,.37,.41,.61,.15,.49,.15,.77Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo24">
			<g id="ce">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="400.3"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,438.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.35" cy="419.2" r="7.8" />
					<g id="cf" className="fk">
						<path
							className="fi"
							d="M772.17,422.06v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M780.39,420.61v1.44h-1.28v-1.44h-2.38l-.18-1.08,2.58-3.46h1.26v3.5h.64v1.04h-.64Zm-1.27-2.88c-.12,.21-.27,.42-.42,.63l-.9,1.21h1.31v-1.22c0-.2,0-.4,.03-.61h-.02Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo23">
			<g id="ch">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="437.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,475.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.35" cy="456.7" r="7.8" />
					<g id="ci" className="fk">
						<path
							className="fi"
							d="M772.17,459.57v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M780.22,457.74c0,.63-.21,1.11-.62,1.45s-1,.51-1.74,.51c-.15,0-.32-.02-.5-.05-.18-.03-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16s.16-.16,.22-.26,.08-.23,.08-.37c0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.17-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46,.08,.18,.13,.38,.13,.59,0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.27,.1,.41,.19,.14,.09,.26,.21,.38,.35,.11,.14,.2,.3,.27,.49s.1,.39,.1,.61Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo22">
			<g id="ck">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="475.3"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,513.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.35" cy="494.2" r="7.8" />
					<g id="cl" className="fk">
						<path
							className="fi"
							d="M772.17,497.09v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M776.72,497.09v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99,.22-.32,.39-.62,.52-.91,.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.23,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63s.16,.54,.16,.87c0,.24-.05,.5-.15,.78-.1,.28-.23,.55-.38,.81-.15,.27-.32,.52-.5,.76-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo21">
			<g id="cn">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="513"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,551h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="775.85" cy="531.9" r="7.8" />
					<g id="co" className="fk">
						<path
							className="fi"
							d="M772.55,534.77v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M778.05,534.77v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo20">
			<g id="cq">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="550.3"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,588.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.55" cy="569.2" r="7.8" />
					<g id="cr" className="fk">
						<path
							className="fi"
							d="M772.05,572.11v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
						<path
							className="fi"
							d="M781.26,569.11c0,.55-.06,1.02-.19,1.42-.12,.4-.29,.72-.51,.98-.21,.25-.46,.44-.74,.56s-.57,.18-.87,.18-.6-.06-.87-.18c-.28-.12-.52-.31-.73-.56-.21-.25-.38-.58-.5-.98-.12-.4-.19-.87-.19-1.42s.06-1.01,.19-1.41c.12-.39,.29-.72,.5-.97,.21-.25,.45-.44,.73-.56,.27-.12,.57-.18,.87-.18s.59,.06,.87,.18,.52,.31,.74,.56c.21,.25,.38,.58,.51,.97,.12,.39,.19,.86,.19,1.41Zm-1.36,0c0-.66-.09-1.14-.28-1.46-.19-.32-.41-.48-.66-.48s-.46,.16-.65,.48c-.19,.32-.28,.81-.28,1.46,0,.33,.03,.62,.08,.87,.05,.25,.12,.45,.2,.61,.08,.16,.18,.28,.29,.36s.23,.12,.36,.12c.25,0,.47-.16,.66-.47,.19-.32,.28-.81,.28-1.48Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo19">
			<g id="ct">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="587.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,625.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.05" cy="606.8" r="7.8" />
					<g id="cu" className="fk">
						<path
							className="fi"
							d="M773.39,609.63v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
						/>
						<path
							className="fi"
							d="M779.98,605.76c0,.41-.06,.81-.19,1.2s-.3,.77-.53,1.12c-.22,.36-.49,.69-.8,.99-.31,.3-.65,.56-1.01,.77l-1.39-.43c.22-.11,.45-.25,.67-.4s.42-.32,.61-.5,.36-.36,.51-.56c.15-.19,.27-.38,.37-.56-.12,.11-.29,.16-.51,.16-.24,0-.47-.05-.71-.14-.24-.09-.45-.22-.64-.39-.19-.17-.35-.38-.46-.63s-.18-.53-.18-.84,.05-.58,.16-.83,.25-.47,.45-.65c.19-.18,.42-.32,.68-.42,.26-.1,.54-.15,.84-.15s.57,.05,.83,.15c.26,.1,.49,.25,.69,.44,.2,.19,.35,.43,.46,.71s.17,.6,.17,.95Zm-1.36-.16c0-.13-.02-.25-.07-.36-.05-.11-.11-.2-.18-.28s-.16-.14-.26-.18c-.1-.04-.21-.07-.32-.07-.21,0-.38,.08-.53,.23s-.22,.35-.22,.59c0,.25,.08,.46,.23,.61,.15,.16,.34,.24,.58,.24,.17,0,.32-.03,.46-.1,.13-.07,.23-.18,.3-.34,.01-.05,.02-.11,.02-.17,0-.06,0-.12,0-.18Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo18">
			<g id="cw">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="625.4"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,663.4h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="776.05" cy="644.3" r="7.8" />
					<g id="cx" className="fk">
						<path
							className="fi"
							d="M773.37,647.14v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
						/>
						<path
							className="fi"
							d="M780.04,645.42c0,.29-.05,.55-.16,.78-.11,.23-.25,.43-.45,.59-.19,.16-.42,.28-.68,.37-.27,.09-.56,.13-.88,.13s-.61-.04-.88-.13c-.27-.09-.49-.21-.68-.37-.19-.16-.34-.35-.45-.59s-.16-.49-.16-.78c0-.19,.03-.37,.1-.54,.07-.17,.15-.31,.25-.44,.1-.13,.21-.24,.32-.32,.12-.09,.22-.15,.31-.19-.1-.04-.2-.11-.29-.2-.09-.09-.17-.19-.24-.3-.07-.11-.13-.24-.17-.37-.04-.13-.07-.27-.07-.42,0-.24,.05-.46,.14-.66s.22-.37,.39-.52,.37-.25,.61-.33c.24-.08,.5-.12,.79-.12s.55,.04,.79,.12c.24,.08,.45,.19,.62,.34,.17,.15,.31,.32,.4,.52,.09,.2,.14,.43,.14,.67,0,.14-.02,.27-.07,.4-.04,.13-.1,.25-.18,.35-.08,.11-.16,.2-.25,.29-.09,.08-.18,.15-.28,.19,.1,.04,.21,.11,.33,.2,.12,.09,.23,.2,.33,.33,.1,.13,.18,.28,.25,.45,.07,.17,.1,.35,.1,.54Zm-1.34,0c0-.11-.03-.22-.08-.31s-.13-.18-.22-.25-.18-.13-.29-.18c-.11-.05-.21-.09-.31-.11-.09,.03-.19,.06-.29,.11-.1,.05-.18,.11-.26,.18s-.14,.15-.2,.25-.08,.2-.08,.31,.02,.22,.07,.31,.11,.18,.19,.24,.17,.12,.28,.16c.1,.04,.21,.06,.32,.06,.12,0,.23-.02,.33-.06,.1-.04,.19-.09,.27-.16s.14-.15,.19-.24,.07-.2,.07-.31Zm-.11-2.69c0-.18-.07-.33-.21-.45-.14-.12-.31-.18-.51-.18s-.36,.06-.49,.18c-.13,.12-.2,.27-.2,.45,0,.16,.07,.31,.2,.44s.31,.22,.53,.28c.22-.06,.39-.16,.5-.28,.12-.12,.17-.27,.17-.43Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo17">
			<g id="d`">
				<g>
					<g>
						<rect
							className="fs"
							x="762.25"
							y="662.9"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M790.85,700.9h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<circle className="ff" cx="775.85" cy="681.8" r="7.8" />
					<g id="da" className="fk">
						<path
							className="fi"
							d="M773.52,684.66v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
						/>
						<path
							className="fi"
							d="M777.66,684.66h-1.43l2.04-4.84h-2.49v-1.14h4.33l-2.46,5.98Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo16">
			<g id="dc">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="662.9"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,700.9h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.65" cy="681.6" r="7.8" />
						<g id="dd" className="fk">
							<path
								className="fi"
								d="M698.94,684.46v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M705.55,682.54c0,.3-.05,.58-.16,.83s-.25,.47-.45,.65c-.19,.18-.42,.32-.68,.42-.26,.1-.54,.15-.84,.15s-.57-.05-.83-.15c-.26-.1-.49-.25-.69-.44-.2-.19-.35-.43-.46-.71-.11-.28-.17-.59-.17-.95,0-.4,.06-.8,.19-1.2,.12-.4,.3-.77,.53-1.13,.22-.36,.49-.68,.8-.98,.31-.3,.65-.56,1.02-.78l1.39,.43c-.22,.11-.45,.25-.67,.4-.22,.15-.42,.32-.61,.5-.19,.18-.36,.36-.51,.56-.15,.19-.27,.38-.37,.56,.12-.11,.29-.16,.51-.16,.24,0,.47,.04,.71,.14,.24,.09,.45,.22,.64,.39s.35,.38,.46,.63c.12,.25,.18,.53,.18,.84Zm-1.33,.03c0-.25-.08-.46-.23-.61s-.35-.24-.59-.24c-.16,0-.31,.03-.45,.1-.13,.07-.23,.18-.3,.34-.01,.05-.02,.11-.02,.17s0,.12,0,.18c0,.26,.08,.47,.25,.64,.17,.16,.36,.24,.58,.24s.39-.08,.54-.23c.15-.15,.22-.35,.22-.59Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo15">
			<g id="df">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="625.4"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,663.4h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.45" cy="644.1" r="7.8" />
						<g id="dg" className="fk">
							<path
								className="fi"
								d="M699.06,646.95v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M705.02,645.08c0,.3-.05,.57-.15,.82-.1,.24-.25,.45-.44,.63-.19,.17-.43,.31-.72,.41-.28,.1-.61,.14-.98,.14-.23,0-.45-.02-.65-.06s-.36-.09-.48-.15l-.12-1.23c.17,.09,.35,.16,.53,.2,.18,.04,.37,.06,.59,.06,.28,0,.52-.08,.7-.22,.19-.15,.28-.35,.28-.59,0-.26-.1-.47-.29-.63-.19-.16-.43-.24-.72-.24-.21,0-.38,.01-.51,.04-.13,.02-.27,.06-.42,.11l.08-3.4h2.82l-.1,1.14h-1.41l-.04,1.07s.06,0,.09,0h.09c.23,0,.46,.05,.68,.14,.22,.09,.41,.22,.59,.39s.31,.37,.41,.61c.1,.23,.16,.49,.16,.77Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo14">
			<g id="di">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="587.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,625.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.65" cy="606.6" r="7.8" />
						<g id="dj" className="fk">
							<path
								className="fi"
								d="M698.97,609.43v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M704.9,607.99v1.44h-1.28v-1.44h-2.38l-.18-1.08,2.58-3.46h1.26v3.5h.64v1.04h-.64Zm-1.27-2.88c-.13,.21-.27,.42-.42,.63l-.9,1.21h1.31v-1.22c0-.2,0-.4,.03-.61h-.02Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo13">
			<g id="dl">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="549.9"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,587.9h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.45" cy="568.6" r="7.8" />
						<g id="dm" className="fk">
							<path
								className="fi"
								d="M699.12,571.48v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M704.88,569.65c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo12">
			<g id="do">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="512.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,550.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.45" cy="531.6" r="7.8" />
						<g id="dp" className="fk">
							<path
								className="fi"
								d="M699.07,534.43v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M701.33,534.43v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo11">
			<g id="dr">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="475.3"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,513.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.15" cy="494.1" r="7.8" />
						<g id="ds" className="fk">
							<path
								className="fi"
								d="M699.45,496.89v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M702.67,496.89v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo10">
			<g id="du">
				<g>
					<g>
						<rect
							className="fs"
							x="687.55"
							y="437.8"
							width="28.1"
							height="37.5"
						/>
						<path
							className="fi"
							d="M716.15,475.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
						/>
					</g>
					<g>
						<circle className="ff" cx="701.65" cy="456.5" r="7.8" />
						<g id="dv" className="fk">
							<path
								className="fi"
								d="M698.95,459.35v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
							/>
							<path
								className="fi"
								d="M705.87,456.35c0,.55-.06,1.02-.19,1.42-.12,.4-.29,.72-.51,.98-.21,.25-.46,.44-.74,.56-.28,.12-.57,.18-.87,.18s-.6-.06-.87-.18-.52-.31-.73-.56c-.21-.25-.38-.58-.5-.98-.12-.4-.19-.87-.19-1.42s.06-1.01,.19-1.41c.12-.39,.29-.72,.5-.97,.21-.25,.45-.44,.73-.56s.57-.18,.87-.18,.59,.06,.87,.18c.28,.12,.52,.31,.74,.56,.21,.25,.38,.58,.51,.97,.12,.39,.19,.86,.19,1.41Zm-1.36,0c0-.66-.09-1.14-.28-1.46-.19-.32-.41-.48-.66-.48s-.46,.16-.65,.48c-.19,.32-.28,.81-.28,1.46,0,.33,.03,.62,.08,.87s.12,.45,.2,.61c.08,.16,.18,.28,.29,.36s.23,.12,.36,.12c.25,0,.47-.16,.66-.47,.19-.32,.28-.81,.28-1.48Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="demo9">
			<g>
				<g>
					<rect
						className="fs"
						x="687.55"
						y="400.3"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M716.15,438.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="701.65" cy="419" r="7.8" />
					<g id="dx" className="fk">
						<path
							className="fi"
							d="M703.79,417.96c0,.41-.06,.81-.19,1.2s-.3,.77-.53,1.12c-.22,.36-.49,.69-.8,.99-.31,.3-.65,.56-1.01,.77l-1.39-.43c.22-.11,.45-.25,.67-.4s.42-.32,.61-.5,.36-.36,.51-.56c.15-.19,.27-.38,.37-.56-.12,.11-.29,.16-.51,.16-.24,0-.47-.05-.71-.14-.24-.09-.45-.22-.64-.39-.19-.17-.35-.38-.46-.63s-.18-.53-.18-.84,.05-.58,.16-.83,.25-.47,.45-.65c.19-.18,.42-.32,.68-.42,.26-.1,.54-.15,.84-.15s.57,.05,.83,.15c.26,.1,.49,.25,.69,.44,.2,.19,.35,.43,.46,.71s.17,.6,.17,.95Zm-1.36-.16c0-.13-.02-.25-.07-.36-.05-.11-.11-.2-.18-.28s-.16-.14-.26-.18c-.1-.04-.21-.07-.32-.07-.21,0-.38,.08-.53,.23s-.22,.35-.22,.59c0,.25,.08,.46,.23,.61,.15,.16,.34,.24,.58,.24,.17,0,.32-.03,.46-.1,.13-.07,.23-.18,.3-.34,.01-.05,.02-.11,.02-.17,0-.06,0-.12,0-.18Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo8">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="400.3"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,438.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="419" r="7.8" />
					<g id="e`" className="fk">
						<path
							className="fi"
							d="M675.7,420.17c0,.29-.05,.55-.16,.78-.11,.23-.25,.43-.45,.59-.19,.16-.42,.28-.68,.37-.27,.09-.56,.13-.88,.13s-.61-.04-.88-.13c-.27-.09-.49-.21-.68-.37-.19-.16-.34-.35-.45-.59s-.16-.49-.16-.78c0-.19,.03-.37,.1-.54,.07-.17,.15-.31,.25-.44,.1-.13,.21-.24,.32-.32,.12-.09,.22-.15,.31-.19-.1-.04-.2-.11-.29-.2-.09-.09-.17-.19-.24-.3-.07-.11-.13-.24-.17-.37-.04-.13-.07-.27-.07-.42,0-.24,.05-.46,.14-.66s.22-.37,.39-.52,.37-.25,.61-.33c.24-.08,.5-.12,.79-.12s.55,.04,.79,.12c.24,.08,.45,.19,.62,.34,.17,.15,.31,.32,.4,.52,.09,.2,.14,.43,.14,.67,0,.14-.02,.27-.07,.4-.04,.13-.1,.25-.18,.35-.08,.11-.16,.2-.25,.29-.09,.08-.18,.15-.28,.19,.1,.04,.21,.11,.33,.2,.12,.09,.23,.2,.33,.33,.1,.13,.18,.28,.25,.45,.07,.17,.1,.35,.1,.54Zm-1.34,0c0-.11-.03-.22-.08-.31s-.13-.18-.22-.25-.18-.13-.29-.18c-.11-.05-.21-.09-.31-.11-.09,.03-.19,.06-.29,.11-.1,.05-.18,.11-.26,.18s-.14,.15-.2,.25-.08,.2-.08,.31,.02,.22,.07,.31,.11,.18,.19,.24,.17,.12,.28,.16c.1,.04,.21,.06,.32,.06,.12,0,.23-.02,.33-.06,.1-.04,.19-.09,.27-.16s.14-.15,.19-.24,.07-.2,.07-.31Zm-.11-2.69c0-.18-.07-.33-.21-.45-.14-.12-.31-.18-.51-.18s-.36,.06-.49,.18c-.13,.12-.2,.27-.2,.45,0,.16,.07,.31,.2,.44s.31,.22,.53,.28c.22-.06,.39-.16,.5-.28,.12-.12,.17-.27,.17-.43Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo7">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="437.8"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,475.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="456.5" r="7.8" />
					<g id="eb" className="fk">
						<path
							className="fi"
							d="M673.46,459.41h-1.43l2.04-4.84h-2.49v-1.14h4.33l-2.46,5.98Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo6">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="475.3"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,513.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="494.1" r="7.8" />
					<g id="ed" className="fk">
						<path
							className="fi"
							d="M675.67,495c0,.3-.05,.58-.16,.83s-.25,.47-.45,.65c-.19,.18-.42,.32-.68,.42-.26,.1-.54,.15-.84,.15s-.57-.05-.83-.15c-.26-.1-.49-.25-.69-.44-.2-.19-.35-.43-.46-.71-.11-.28-.17-.59-.17-.95,0-.4,.06-.8,.19-1.2,.12-.4,.3-.77,.53-1.13,.22-.36,.49-.68,.8-.98,.31-.3,.65-.56,1.02-.78l1.39,.43c-.22,.11-.45,.25-.67,.4-.22,.15-.42,.32-.61,.5-.19,.18-.36,.36-.51,.56-.15,.19-.27,.38-.37,.56,.12-.11,.29-.16,.51-.16,.24,0,.47,.04,.71,.14,.24,.09,.45,.22,.64,.39s.35,.38,.46,.63c.12,.25,.18,.53,.18,.84Zm-1.33,.03c0-.25-.08-.46-.23-.61s-.35-.24-.59-.24c-.16,0-.31,.03-.45,.1-.13,.07-.23,.18-.3,.34-.01,.05-.02,.11-.02,.17s0,.12,0,.18c0,.26,.08,.47,.25,.64,.17,.16,.36,.24,.58,.24s.39-.08,.54-.23c.15-.15,.22-.35,.22-.59Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo5">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="512.8"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,550.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="531.6" r="7.8" />
					<g id="ef" className="fk">
						<path
							className="fi"
							d="M675.25,532.57c0,.3-.05,.57-.15,.82-.1,.24-.25,.45-.44,.63-.19,.17-.43,.31-.72,.41-.28,.1-.61,.14-.98,.14-.23,0-.45-.02-.65-.06s-.36-.09-.48-.15l-.12-1.23c.17,.09,.35,.16,.53,.2,.18,.04,.37,.06,.59,.06,.28,0,.52-.08,.7-.22,.19-.15,.28-.35,.28-.59,0-.26-.1-.47-.29-.63-.19-.16-.43-.24-.72-.24-.21,0-.38,.01-.51,.04-.13,.02-.27,.06-.42,.11l.08-3.4h2.82l-.1,1.14h-1.41l-.04,1.07s.06,0,.09,0h.09c.23,0,.46,.05,.68,.14,.22,.09,.41,.22,.59,.39s.31,.37,.41,.61c.1,.23,.16,.49,.16,.77Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo4">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="550.3"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,588.3h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="569.1" r="7.8" />
					<g id="eh" className="fk">
						<path
							className="fi"
							d="M675.01,570.5v1.44h-1.28v-1.44h-2.38l-.18-1.08,2.58-3.46h1.26v3.5h.64v1.04h-.64Zm-1.27-2.88c-.13,.21-.27,.42-.42,.63l-.9,1.21h1.31v-1.22c0-.2,0-.4,.03-.61h-.02Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo3">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="587.8"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,625.8h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="606.6" r="7.8" />
					<g id="ej" className="fk">
						<path
							className="fi"
							d="M675.14,607.63c0,.63-.21,1.11-.62,1.45-.42,.34-1,.51-1.74,.51-.15,0-.32-.02-.5-.05s-.34-.08-.49-.14l-.12-1.21c.16,.09,.33,.15,.51,.18,.18,.03,.36,.05,.54,.05,.12,0,.25-.02,.37-.05,.12-.04,.22-.09,.31-.16,.09-.07,.16-.16,.22-.26,.06-.1,.08-.23,.08-.37,0-.11-.02-.21-.07-.31-.04-.1-.11-.18-.19-.25-.08-.07-.18-.13-.28-.17s-.22-.07-.34-.07c-.08,0-.17,0-.28,.03l-.11-1.06c.25-.06,.46-.15,.61-.28,.16-.13,.24-.28,.24-.46,0-.15-.05-.28-.16-.38-.11-.1-.26-.15-.46-.15-.16,0-.29,.01-.41,.04-.12,.03-.25,.08-.39,.15l-.1-1.11c.16-.07,.33-.13,.51-.17,.18-.04,.39-.06,.62-.06,.27,0,.51,.04,.73,.11,.22,.07,.41,.17,.56,.3,.16,.13,.28,.28,.36,.46s.13,.38,.13,.59c0,.29-.07,.55-.22,.75-.14,.21-.31,.36-.49,.44,.14,.04,.28,.1,.41,.19,.14,.09,.26,.21,.38,.35s.2,.3,.27,.49c.07,.18,.1,.39,.1,.61Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo2">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="625.4"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,663.4h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="644.1" r="7.8" />
					<g id="el" className="fk">
						<path
							className="fi"
							d="M671.55,646.98v-.37c.31-.31,.6-.64,.88-.97,.28-.34,.53-.67,.75-.99s.39-.62,.53-.91c.13-.29,.2-.54,.2-.76,0-.3-.08-.53-.25-.68-.17-.16-.38-.23-.64-.23-.22,0-.43,.03-.63,.1-.19,.07-.38,.16-.56,.27l-.11-1.21c.19-.11,.4-.2,.64-.27,.24-.07,.5-.1,.79-.1,.31,0,.59,.04,.85,.13,.26,.08,.49,.21,.68,.38,.19,.17,.34,.38,.45,.63,.11,.25,.16,.54,.16,.87,0,.24-.05,.5-.15,.78-.1,.28-.22,.55-.38,.81s-.32,.52-.5,.76c-.18,.24-.35,.45-.52,.62h1.85v1.14h-4.05Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="demo1">
			<g>
				<g>
					<rect
						className="fs"
						x="659.45"
						y="662.9"
						width="28.1"
						height="37.5"
					/>
					<path
						className="fi"
						d="M688.05,700.9h-29.1v-38.5h29.1v38.5Zm-28.1-1h27.1v-36.5h-27.1v36.5Z"
					/>
				</g>
				<g>
					<circle className="ff" cx="673.55" cy="681.6" r="7.8" />
					<g id="en" className="fk">
						<path
							className="fi"
							d="M673.27,684.49v-4.8l-1.06,.09,.1-1.19,2.32-.21v6.11h-1.36Z"
						/>
					</g>
				</g>
			</g>
		</g>
		<g id="eo">
			<g>
				<polygon
					className="fv"
					points="528.65 474.4 528.65 475.3 570.65 475.3 570.65 452.6 537.65 452.6 543.75 437.6 570.65 437.6 570.65 415 528.65 415 528.65 415 528.65 415 513.75 450.1 195.65 320.2 187.05 341.3 505.05 471.1 487.65 512.3 512.95 512.3 571.25 512.3 571.25 489.7 522.35 489.7 528.65 474.4"
				/>
				<path
					className="fv"
					d="M830.55,365.1v-124.6h0v-22.7h-171.3v22.7h67.6v80.8h22.7v-80.8h67.5v124.6h-168v-9.7h-22.7v378.7h227.9V365.1h-23.7Zm-103.9,346.2h-78.2V389.3h78.2v322Zm102.9,0h-78.2V389.3h78.2v322Z"
				/>
			</g>
			<g id="ep">
				<g>
					<path
						className="fn"
						d="M770.75,874l-1.4-4.1-.6-.2-.9,3.4-2-.6,2.3-8.6,3.1,.9c1.4,.5,2.5,1.7,2,3.4-.3,.9-1.1,1.7-1.9,1.9l1.7,4.7-2.3-.8Zm-.2-7.5l-.8-.2-.5,1.9,.8,.2c.5,.2,1.1,0,1.4-.6,.2-.6-.3-1.1-.9-1.3Z"
					/>
					<path
						className="fn"
						d="M773.55,874.8l2.3-8.6,5,1.4-.5,1.7-3-.8-.5,1.7,2.3,.6-.5,1.7-2.3-.6-.5,1.7,3.3,.9-.5,1.7-5.1-1.4Z"
					/>
					<path
						className="fn"
						d="M784.15,878c-2.3-.6-4.4-2.8-3.6-5.8,.8-3,3.8-3.9,5.9-3.3,1.3,.3,2.2,.9,2.7,1.6l-.9,1.6c-.5-.5-1.3-.9-2-1.3-1.6-.5-3.1,.3-3.6,2-.5,1.6,.5,3,2,3.4,.5,.2,.9,.2,1.3,0l.3-1.4-1.6-.5,.5-1.6,3.4,.9-1.1,4.1c-.8,.7-1.9,.7-3.3,.3Z"
					/>
					<path className="fn" d="M788.85,879l2.3-8.6,2,.6-2.2,8.6-2.1-.6Z" />
					<path
						className="fn"
						d="M794.95,880.9c-.9-.3-1.9-.8-2.2-1.3l.3-2c.6,.6,1.4,1.3,2.3,1.6,.8,.2,1.3,0,1.4-.5,.2-.5-.2-.9-.8-1.3-1.6-.9-2-2-1.7-3.4,.5-1.4,1.7-2.3,3.6-1.7,.9,.3,1.7,.8,2,1.1l-.8,1.6c-.3-.3-.9-.8-1.6-.9-.8-.2-1.1,0-1.3,.5s.2,.8,.8,1.1c1.6,.9,2.3,2,1.9,3.6-.5,1.5-1.9,2.1-3.9,1.6Z"
					/>
					<path
						className="fn"
						d="M804.65,875.9l-1.9,6.9-2-.6,1.9-6.9-2.5-.6,.5-1.7,7,1.9-.5,1.7-2.5-.7Z"
					/>
					<path
						className="fn"
						d="M810.95,885.1l-1.4-4.1-.6-.2-.9,3.4-2-.6,2.3-8.6,3.1,.9c1.4,.5,2.5,1.7,2,3.4-.3,.9-1.1,1.7-1.9,1.9l1.7,4.7-2.3-.8Zm-.2-7.5l-.8-.2-.5,1.9,.8,.2c.5,.2,1.1,0,1.4-.6,.2-.6-.3-1.1-.9-1.3Z"
					/>
					<path
						className="fn"
						d="M819.35,887.5l-.2-2.2-2.8-.8-1.3,1.7-2-.5,5.8-7.8,1.4,.5,.9,9.7-1.8-.6Zm-.5-5.8v-.9h0c-.2,.3-.3,.5-.5,.8l-1.1,1.4,1.7,.5-.1-1.8Z"
					/>
					<path
						className="fn"
						d="M826.95,882.2l-1.9,6.9-2-.6,1.9-6.9-2.5-.6,.5-1.7,7,1.9-.5,1.7-2.5-.7Z"
					/>
					<path className="fn" d="M828.55,890l2.3-8.6,2,.6-2.3,8.6-2-.6Z" />
					<path
						className="fn"
						d="M836.55,892.5c-2.3-.6-4.2-3-3.4-5.8s3.4-3.9,5.9-3.3c2.3,.6,4.2,3,3.4,5.8s-3.6,3.9-5.9,3.3Zm2-7.2c-1.3-.3-2.8,.3-3.3,2-.5,1.6,.5,3,1.7,3.4,1.3,.3,2.8-.3,3.3-2s-.4-3.1-1.7-3.4Z"
					/>
					<path
						className="fn"
						d="M849.35,895.9l-2.3-4.7c-.3-.8-.8-1.6-1.1-2.3h0c-.2,.6-.3,1.3-.5,1.9l-1.1,3.8-2-.6,2.3-8.6,1.7,.5,2,4.1c.3,.6,.8,1.4,.9,2h0c.2-.5,.3-1.1,.5-1.6l.9-3.3,2,.6-2.3,8.8-1-.6Z"
					/>
					<path
						className="fn"
						d="M773.55,895.6l-.3-.6c-.8,.2-1.7,.2-2.7,0-1.9-.5-2.7-1.9-2.3-3.3,.3-1.1,.9-1.6,2-1.9-.5-.8-.5-1.6-.3-2.2,.5-1.4,1.9-2,3.3-1.7,1.4,.5,2.5,1.7,2,3.1-.3,.9-.9,1.6-2.2,1.9l.9,1.7c.6-.5,1.1-.9,1.6-1.4l.9,1.7c-.5,.6-.9,1.1-1.6,1.4l1.1,2-2.4-.7Zm-2.5-4.4c-.5,.2-.8,.3-.9,.8-.2,.5,.2,1.1,.8,1.3,.5,.2,.8,.2,1.3,0l-1.2-2.1Zm1.7-3.7c-.5-.2-.9,.2-.9,.5-.2,.3,.2,.8,.5,1.3,.8-.2,1.1-.5,1.3-.8-.3-.4-.4-.9-.9-1Z"
					/>
					<path
						className="fn"
						d="M788.55,899.8l-1.4-.3-.2-4.2v-2h0c-.5,.6-.8,1.3-1.1,1.7l-2.3,3.4-1.3-.3-.5-9.5,2,.6,.2,3.8v1.9h0c.3-.6,.6-1.1,.9-1.6l2-3.1,1.9,.5,.2,3.8v1.9h0c.3-.6,.6-1.1,.9-1.6l2.2-3.1,1.9,.5-5.4,7.6Z"
					/>
					<path
						className="fn"
						d="M792.25,900.8l2.3-8.6,5,1.4-.5,1.7-3-.8-.5,1.7,2.3,.6-.5,1.7-2.3-.6-.5,1.7,3.3,.9-.5,1.7-5.1-1.4Z"
					/>
					<path
						className="fn"
						d="M798.35,902.5l2.3-8.6,2,.6-1.9,6.9,3.3,.9-.5,1.7-5.2-1.5Z"
					/>
					<path
						className="fn"
						d="M812.45,899.4c-.3-.3-.9-.8-1.7-.9-1.6-.5-3.1,.3-3.4,1.9-.5,1.6,.5,3,2.2,3.4,.8,.2,1.4,.3,1.9,.2l-.6,1.7c-.5,.2-1.3,0-2-.2-2.2-.6-4.2-2.8-3.4-5.8s3.6-3.8,5.9-3.1c1.1,.3,1.9,.8,2.3,1.3l-1.2,1.5Z"
					/>
					<path
						className="fn"
						d="M816.25,907.7c-2.3-.6-4.2-3-3.4-5.8s3.4-3.9,5.9-3.3c2.3,.6,4.2,3,3.4,5.8-.8,2.6-3.6,3.9-5.9,3.3Zm1.8-7.2c-1.3-.3-2.8,.3-3.3,2-.5,1.6,.5,3,1.7,3.4,1.3,.3,2.8-.3,3.3-2,.7-1.7-.3-3.1-1.7-3.4Z"
					/>
					<path
						className="fn"
						d="M829.95,911.2l.6-3.3c.2-.5,.2-1.1,.3-1.6h0c-.3,.5-.8,.9-1.3,1.4l-2.5,2.8-.8-.2-.8-3.6c-.2-.6-.2-1.3-.3-1.9h0c-.2,.6-.3,1.1-.5,1.6l-1.1,3.1-2-.5,3.1-8.4,1.7,.5,.9,4.2c.2,.6,.3,1.4,.3,2h0c.3-.5,.9-1.1,1.4-1.6l2.8-3.1,1.6,.5-1.6,8.9-1.8-.8Z"
					/>
					<path
						className="fn"
						d="M833.25,912l2.3-8.6,5,1.4-.5,1.7-3-.8-.5,1.7,2.3,.6-.5,1.7-2.3-.6-.5,1.7,3.3,.9-.5,1.7-5.1-1.4Z"
					/>
				</g>
			</g>
			<g id="eq">
				<g>
					<path
						className="fn"
						d="M723.65,560.8h-3.3v-8.9h3.3c2.7,0,4.8,1.9,4.7,4.7,0,2.8-2,4.2-4.7,4.2Zm-.3-6.4h-.3v4.1h.3c1.1,0,1.9-.5,1.9-1.9,.1-1.4-.8-2.2-1.9-2.2Z"
					/>
					<path
						className="fn"
						d="M729.35,560.8v-8.9h5.5v2.3h-2.5v.8h2v2.5h-2v.8h3v2.3h-5.9l-.1,.2h0Z"
					/>
					<path
						className="fn"
						d="M743.65,560.8l-.2-2.5v-1.3h0c-.2,.5-.3,.9-.5,1.3l-1.3,2.5h-1.3l-1.3-2.5c-.2-.5-.3-.8-.5-1.3h0v1.3l-.2,2.5h-2.5l.8-8.9h2.8l1.6,3c.2,.5,.5,.9,.6,1.6h0c.2-.5,.5-1.1,.6-1.6l1.6-3h2.5l.8,8.9h-3.5Z"
					/>
					<path
						className="fn"
						d="M752.15,561.1c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7c.2,2.8-2.2,4.7-4.8,4.7Zm0-6.9c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2c0-1-.8-2-1.9-2Z"
					/>
					<path
						className="fn"
						d="M721.15,571.1v.8h2v2.5h-2v3.3h-3v-8.9h5.5v2.3h-2.5Z"
					/>
					<path className="fn" d="M724.35,577.7v-8.9h3v6.6h2.8v2.3h-5.8Z" />
					<path
						className="fn"
						d="M735.25,578c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7-2.3,4.7-4.8,4.7Zm0-6.9c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2c-.2-1-1-2-1.9-2Z"
					/>
					<path
						className="fn"
						d="M745.75,578c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7-2.3,4.7-4.8,4.7Zm0-6.9c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2c-.1-1-1-2-1.9-2Z"
					/>
					<path
						className="fn"
						d="M756.35,577.7l-2-3.1h-.2v3.1h-2.8v-8.9h3.9c1.9,0,3.1,1.3,3.1,3,0,.9-.5,1.9-1.1,2.2l2.7,3.9-3.6-.2h0Zm-1.4-6.6h-.6v1.3h.6c.3,0,.6-.2,.6-.6s-.3-.7-.6-.7Z"
					/>
				</g>
			</g>
			<g>
				<path
					className="fn"
					d="M298.05,375h-3.3v-8.9h3.3c2.7,0,4.8,1.9,4.8,4.5-.1,2.5-2.1,4.4-4.8,4.4Zm-.3-6.6h-.3v4.2h.3c1.1,0,2-.8,2-2,0-1.3-.9-2.2-2-2.2Z"
				/>
				<path
					className="fn"
					d="M303.65,375v-8.9h5.5v2.3h-2.7v.8h2v2.5h-2v.8h3v2.3l-5.8,.2h0Z"
				/>
				<path
					className="fn"
					d="M318.05,375l-.2-2.5v-1.3h0c-.2,.5-.3,.9-.5,1.3l-1.3,2.5h-1.3l-1.3-2.5c-.2-.5-.3-.8-.5-1.3h0v1.3l-.2,2.5h-2.8l.8-8.9h2.8l1.6,3c.2,.5,.5,.9,.6,1.6h0c.2-.5,.5-1.1,.6-1.6l1.6-3h2.5l.8,8.9h-3.2Z"
				/>
				<path
					className="fn"
					d="M326.55,375.1c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7c.2,2.8-2.2,4.7-4.8,4.7Zm0-6.7c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2-.9-2-1.9-2Z"
				/>
				<path
					className="fn"
					d="M295.55,385.3v.8h2v2.5h-2v3.3h-3v-8.9h5.5v2.3h-2.5Z"
				/>
				<path className="fn" d="M298.65,391.8v-8.9h3v6.6h2.8v2.3h-5.8Z" />
				<path
					className="fn"
					d="M309.65,392c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7c0,2.8-2.3,4.7-4.8,4.7Zm0-6.7c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2-1-2-1.9-2Z"
				/>
				<path
					className="fn"
					d="M320.05,392c-2.5,0-4.8-1.9-4.8-4.7s2.3-4.7,4.8-4.7,4.8,1.9,4.8,4.7c.1,2.8-2.3,4.7-4.8,4.7Zm0-6.7c-1.1,0-1.9,.9-1.9,2s.8,2,1.9,2,1.9-.9,1.9-2-.9-2-1.9-2Z"
				/>
				<path
					className="fn"
					d="M330.75,391.8l-2-3.1h-.2v3.1h-2.8v-8.9h3.9c1.9,0,3.1,1.3,3.1,3,0,.9-.5,1.9-1.1,2.2l2.7,3.9-3.6-.2h0Zm-1.4-6.7h-.6v1.3h.6c.3,0,.6-.2,.6-.6s-.3-.7-.6-.7Z"
				/>
			</g>
			<g id="er">
				<g>
					<g>
						<polygon
							className="fj"
							points="794.15 71.6 682.45 71.6 682.45 147.1 794.15 147.2 794.15 71.6"
						/>
						<path
							className="fo"
							d="M794.65,147.7l-112.7-.1V71.1h112.7v76.6Zm-111.7-1.1l110.7,.1V72.1h-110.7v74.5Z"
						/>
					</g>
					<path
						className="fo"
						d="M794.95,148l-113.3-.2V70.8h113.3v77.2Zm-111.8-1.7l110.2,.2V72.3h-110.2v74Z"
					/>
				</g>
				<g>
					<path
						className="ff"
						d="M712.15,110.9c-.3-.2-.9-.3-1.4-.3-1.3,0-2.2,.8-2.2,2.2,0,1.3,.9,2.2,2.3,2.2,.6,0,1.1-.2,1.4-.3l-.2,1.4c-.3,.2-.9,.3-1.6,.3-1.9,0-3.8-1.3-3.8-3.6s1.9-3.6,3.8-3.6c.9,0,1.6,.2,2,.5l-.3,1.2Z"
					/>
					<path className="ff" d="M713.35,116.3v-7h1.7v5.6h2.7v1.4h-4.4Z" />
					<path
						className="ff"
						d="M721.65,116.4c-1.9,0-3.8-1.4-3.8-3.6s1.9-3.6,3.8-3.6,3.8,1.4,3.8,3.6-1.8,3.6-3.8,3.6Zm0-5.8c-1.1,0-2,.8-2,2.2s.9,2.2,2,2.2,2-.8,2-2.2-.9-2.2-2-2.2Z"
					/>
					<path
						className="ff"
						d="M730.55,116.3l-.6-1.6h-2.2l-.6,1.6h-1.6l2.8-7h1.1l2.8,7h-1.7Zm-1.6-4.3c0-.2-.2-.5-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.3h1.4l-.5-1.3Z"
					/>
					<path
						className="ff"
						d="M736.65,116.3l-2-2.8h0v2.8h-1.7v-7h1.7v3h0l2.2-3h1.9l-2.5,3.4,2.5,3.6h-2.1Z"
					/>
					<path
						className="ff"
						d="M743.25,116.3l-1.9-2.8h-.5v2.8h-1.6v-7h2.5c1.3,0,2.2,.8,2.2,2.2,0,.8-.5,1.4-1.1,1.7l2.2,3.1h-1.8Zm-1.6-5.7h-.6v1.6h.6c.5,0,.9-.3,.9-.8-.1-.6-.6-.8-.9-.8Z"
					/>
					<path
						className="ff"
						d="M748.65,116.4c-1.9,0-3.8-1.4-3.8-3.6s1.9-3.6,3.8-3.6,3.8,1.4,3.8,3.6-1.9,3.6-3.8,3.6Zm0-5.8c-1.1,0-2,.8-2,2.2s.9,2.2,2,2.2,2-.8,2-2.2c.1-1.4-.9-2.2-2-2.2Z"
					/>
					<path
						className="ff"
						d="M756.95,116.4c-1.9,0-3.8-1.4-3.8-3.6s1.9-3.6,3.8-3.6,3.8,1.4,3.8,3.6-1.9,3.6-3.8,3.6Zm0-5.8c-1.1,0-2,.8-2,2.2s.9,2.2,2,2.2,2-.8,2-2.2c.1-1.4-1-2.2-2-2.2Z"
					/>
					<path
						className="ff"
						d="M768.05,116.3l-.2-2.5v-1.3h0c-.2,.5-.5,.9-.6,1.3l-1.3,2.5h-.6l-1.4-2.5c-.2-.5-.5-.8-.6-1.3h0v1.3l-.2,2.5h-1.6l.6-7h1.4l1.6,3c.2,.5,.5,1.1,.6,1.6h0c.2-.5,.5-1.1,.6-1.6l1.6-3h1.3l.6,7h-1.8Z"
					/>
				</g>
			</g>
			<g id="toiletten">
				<g>
					<g>
						<rect
							className="fj"
							x="599.55"
							y="4.5"
							width="306.4"
							height="44.4"
						/>
						<path
							className="fo"
							d="M906.45,49.4h-307.4V4h307.4V49.4Zm-306.4-1h305.4V5h-305.4V48.4Z"
						/>
					</g>
					<path
						className="fo"
						d="M906.75,49.5h-308V3.5h307.9l.1,46h0Zm-306.4-1.5h304.8V5.1h-304.8V48Z"
					/>
				</g>
				<g>
					<g>
						<path
							className="ff"
							d="M761.05,43h-22.2c-2.8,0-5-2.3-5-5V15.8c0-2.8,2.3-5,5-5h22.2c2.8,0,5,2.3,5,5v22.2c.1,2.6-2.2,5-5,5Z"
						/>
						<path
							className="fr"
							d="M761.05,43.7h-22.2c-3.3,0-5.8-2.7-5.8-5.8V15.8c0-3.3,2.7-5.8,5.8-5.8h22.2c3.3,0,5.8,2.7,5.8,5.8v22.2c.1,3.1-2.5,5.7-5.8,5.7Zm-22.2-32.3c-2.3,0-4.2,1.9-4.2,4.2v22.2c0,2.3,1.9,4.2,4.2,4.2h22.2c2.3,0,4.2-1.9,4.2-4.2V15.6c0-2.3-1.9-4.2-4.2-4.2h-22.2Z"
						/>
					</g>
					<g>
						<g>
							<path
								className="fu"
								d="M745.55,19.8h-4.7c-1.1,0-2,.9-2,2v6.6c0,.5,.5,.9,.9,.9h0c.5,0,.9-.5,.9-.9v-6.6h0c0-.2,.2-.2,.2-.2,.2,0,.2,.2,.2,.2v14.8c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-8.4h.5v8.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-14.8c0-.2,.2-.2,.2-.2q.2,0,.2,.2h0v6.6c0,.5,.5,.9,.9,.9h0c.5,0,.9-.5,.9-.9v-6.6h0c-.6-1-1.5-2-2.6-2h0Z"
							/>
							<path
								className="fu"
								d="M744.95,17.5c0,.9-.8,1.9-1.9,1.9-.9,0-1.9-.8-1.9-1.9,0-.9,.8-1.9,1.9-1.9s1.9,.8,1.9,1.9h0Z"
							/>
							<path
								className="fu"
								d="M762.65,27s-1.6-4.7-1.9-5.3c-.5-1.3-1.1-1.7-2-1.7h-3.1c-.9,0-1.6,.6-2,1.7-.3,.8-1.9,5.3-1.9,5.3-.2,.5,.2,.9,.5,1.1,.5,.2,.9-.2,1.1-.5,0-.2,1.1-2.8,1.6-4.4,0,.5,.2-.5-1.3,6.6,0,.3,.2,.6,.5,.6h.6v6.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-6.3h.5v6.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-6.4h.6c.3,0,.5-.3,.5-.6-1.4-7-1.3-6.1-1.3-6.6,.5,1.6,1.4,4.2,1.6,4.4,.2,.5,.6,.6,1.1,.5,.5-.1,.6-.7,.5-1.2h0Z"
							/>
						</g>
						<path
							className="fu"
							d="M759.05,17.5c0,.9-.8,1.9-1.9,1.9s-1.9-.8-1.9-1.9,.8-1.9,1.9-1.9,1.9,.9,1.9,1.9h0Z"
						/>
						<path
							className="fu"
							d="M749.95,16.9c-.3,0-.6,.3-.6,.6v18.6c0,.3,.3,.6,.6,.6s.6-.3,.6-.6V17.5c0-.3-.3-.6-.6-.6h0Z"
						/>
					</g>
				</g>
				<g>
					<g>
						<polygon
							className="fj"
							points="829.55 147.1 798.05 147.2 798.05 71.6 829.55 71.4 829.55 147.1"
						/>
						<path
							className="fo"
							d="M797.55,147.7V71.1l32.5-.21v76.7l-32.5,.1Zm1-75.6v74.6l30.5-.1V71.9l-30.5,.19Z"
						/>
					</g>
					<path
						className="fo"
						d="M797.35,148V70.8l33-.2v77.2l-33,.2Zm1.5-75.7v74.1l29.9-.2V72.2l-29.9,.1Z"
					/>
				</g>
				<g>
					<g>
						<path
							className="ff"
							d="M819.85,117.4h-10.6c-2.8,0-5-2.3-5-5v-10.6c0-2.8,2.3-5,5-5h10.6c2.8,0,5,2.3,5,5v10.6c0,2.6-2.2,5-5,5Z"
						/>
						<path
							className="fr"
							d="M819.85,118.1h-10.6c-3.3,0-5.8-2.7-5.8-5.8v-10.6c0-3.3,2.7-5.8,5.8-5.8h10.6c3.3,0,5.8,2.7,5.8,5.8v10.6c-.1,3.2-2.7,5.8-5.8,5.8Zm-10.7-20.6c-2.3,0-4.2,1.9-4.2,4.2v10.6c0,2.3,1.9,4.2,4.2,4.2h10.7c2.3,0,4.2-1.9,4.2-4.2v-10.6c0-2.3-1.9-4.2-4.2-4.2h-10.7Z"
						/>
					</g>
					<g>
						<path
							className="fu"
							d="M815.75,111.3c-.3,.6-.8,1.1-1.4,1.4-.6,.3-1.3,.5-1.9,.5-.9,0-1.9-.3-2.7-1.1-.8-.8-1.1-1.6-1.1-2.7,0-.8,.2-1.4,.6-2s.9-1.1,1.6-1.4l-.2-1.1c-.9,.3-1.7,.9-2.2,1.7-.6,.8-.8,1.7-.8,2.7,0,.8,.2,1.6,.6,2.3s.9,1.3,1.7,1.7,1.6,.6,2.3,.6c1.1,0,1.9-.3,2.8-.9,.8-.6,1.4-1.4,1.7-2.3l-.8-1.7c.3,1,.1,1.6-.2,2.3h0Z"
						/>
						<path
							className="fu"
							d="M820.75,110.2l-1.6,.8-1.9-3.8c-.2-.2-.3-.3-.5-.3h-3.8l-.2-1.1h3.3v-1.1h-3.4l-.3-2.3c.3,0,.6,0,.9-.3,.3-.3,.5-.6,.5-.9s-.2-.6-.3-.9c-.3-.3-.6-.3-.9-.3s-.6,.2-.8,.3c-.3,.2-.3,.5-.5,.6v.3l.8,6.4c0,.2,0,.3,.2,.3q.2,.2,.3,.2h3.9l2,3.9c.2,.2,.3,.3,.5,.3h.3l2-1.1-.5-1Z"
						/>
					</g>
				</g>
			</g>
			<g id="toiletten">
				<g>
					<g>
						<polygon
							className="fj"
							points="82.65 419.8 22.75 565.3 121.45 602.2 164.25 494.1 193.65 506.1 208.05 469.2 82.65 419.8"
						/>
						<path
							className="fo"
							d="M121.74,602.84l-.46-.17-99.18-37.08,.2-.48,60.09-145.96,.46,.18,125.86,49.58-14.77,37.84-29.4-12-42.79,108.09Zm-98.33-37.83l97.76,36.55,42.81-108.11,29.4,12,14.03-35.96-124.48-49.04-59.52,144.57Z"
						/>
					</g>
					<path
						className="fo"
						d="M121.85,603.3l-.8-.3-99.2-37.2,.3-.8,60-146.1,126.9,49.9-15,38.5-29.4-12-42.8,108Zm-98-38.4l97.1,36.4,43-108.2,29.2,12,13.9-35.5-124-48.8-59.2,144.1Z"
					/>
				</g>
				<g>
					<g>
						<g>
							<path
								className="ff"
								d="M115.35,520.6h-22.2c-2.8,0-5-2.3-5-5v-22.2c0-2.8,2.3-5,5-5h22.2c2.8,0,5,2.3,5,5v22.2c.1,2.8-2.2,5-5,5Z"
							/>
							<path
								className="fo"
								d="M115.35,521.1h-22.2c-3.03,0-5.5-2.47-5.5-5.5v-22.2c0-3.03,2.47-5.5,5.5-5.5h22.2c3.03,0,5.5,2.47,5.5,5.5v22.2c.05,1.42-.47,2.78-1.47,3.81-1.04,1.07-2.51,1.69-4.03,1.69Zm-22.2-32.2c-2.48,0-4.5,2.02-4.5,4.5v22.2c0,2.48,2.02,4.5,4.5,4.5h22.2c1.26,0,2.46-.5,3.31-1.38,.81-.84,1.23-1.94,1.19-3.1v-22.22c0-2.48-2.02-4.5-4.5-4.5h-22.2Z"
							/>
						</g>
						<path
							className="fr"
							d="M115.35,521.4h-22.2c-3.3,0-5.8-2.7-5.8-5.8v-22.2c0-3.3,2.7-5.8,5.8-5.8h22.2c3.3,0,5.8,2.7,5.8,5.8v22.2c.1,3.3-2.5,5.8-5.8,5.8Zm-22.2-32.2c-2.3,0-4.2,1.9-4.2,4.2v22.2c0,2.3,1.9,4.2,4.2,4.2h22.2c2.3,0,4.2-1.9,4.2-4.2v-22.2c0-2.3-1.9-4.2-4.2-4.2h-22.2Z"
						/>
					</g>
					<g>
						<g>
							<path
								className="fu"
								d="M99.85,497.7h-4.7c-1.1,0-2,.9-2,2v6.6c0,.5,.5,.9,.9,.9h0c.5,0,.9-.5,.9-.9v-6.6h0c0-.2,.2-.2,.2-.2,.2,0,.2,.2,.2,.2v14.8c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-8.4h.5v8.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-14.8c0-.2,.2-.2,.2-.2q.2,0,.2,.2h0v6.6c0,.5,.5,.9,.9,.9h0c.5,0,.9-.5,.9-.9v-6.6h0c-.6-1.1-1.5-2-2.6-2h0Z"
							/>
							<path
								className="fu"
								d="M99.25,495.2c0,.9-.8,1.9-1.9,1.9-.9,0-1.9-.8-1.9-1.9,0-.9,.8-1.9,1.9-1.9,1.1,.1,1.9,.9,1.9,1.9h0Z"
							/>
							<path
								className="fu"
								d="M116.85,504.8s-1.6-4.7-1.9-5.3c-.5-1.3-1.1-1.7-2-1.7h-3.1c-.9,0-1.6,.6-2,1.7-.3,.8-1.9,5.3-1.9,5.3-.2,.5,.2,.9,.5,1.1,.5,.2,.9-.2,1.1-.5,0-.2,1.1-2.8,1.6-4.4,0,.5,.2-.5-1.3,6.6,0,.3,.2,.6,.5,.6h.6v6.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-6.4h.5v6.4c0,.6,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-6.4h.6c.3,0,.5-.3,.5-.6-1.4-7-1.3-6.1-1.3-6.6,.5,1.6,1.4,4.2,1.6,4.4,.2,.5,.6,.6,1.1,.5,.5-.1,.7-.6,.5-1.1h0Z"
							/>
						</g>
						<path
							className="fu"
							d="M113.25,495.3c0,.9-.8,1.9-1.9,1.9s-1.9-.8-1.9-1.9,.8-1.9,1.9-1.9,1.9,.8,1.9,1.9h0Z"
						/>
						<path
							className="fu"
							d="M104.25,494.5c-.3,0-.6,.3-.6,.6v18.6c0,.3,.3,.6,.6,.6s.6-.3,.6-.6v-18.6c0-.3-.3-.6-.6-.6h0Z"
						/>
					</g>
				</g>
			</g>
			<g id="lounge">
				<g>
					<rect className="fq" x="959.75" y="384" width="81.1" height="296.7" />
					<path
						className="fp"
						d="M1041.45,681.5h-82.7V383.2h82.7v298.3Zm-81-1.6h79.6V384.8h-79.6v295.1Z"
					/>
				</g>
				<g>
					<path className="ff" d="M977.95,535.3v-8h1.9v6.4h3v1.6h-4.9Z" />
					<path
						className="ff"
						d="M987.35,535.5c-2.2,0-4.4-1.6-4.4-4.2s2-4.2,4.4-4.2c2.2,0,4.2,1.6,4.2,4.2s-2,4.2-4.2,4.2Zm0-6.6c-1.3,0-2.3,.9-2.3,2.5s1.1,2.5,2.3,2.5c1.3,0,2.3-.9,2.3-2.5,.1-1.5-1-2.5-2.3-2.5Z"
					/>
					<path
						className="ff"
						d="M996.15,535.5c-1.9,0-3.4-1.1-3.4-3v-5.2h1.9v5c0,.9,.6,1.6,1.6,1.6s1.6-.6,1.6-1.6v-5h1.9v5.2c-.2,1.9-1.7,3-3.6,3Z"
					/>
					<path
						className="ff"
						d="M1007.35,535.5l-3.1-3.4c-.5-.6-1.1-1.3-1.6-1.7h0v5.1h-1.9v-8h1.6l2.8,3c.3,.5,.9,1.1,1.3,1.6h0v-4.6h1.9v8.1l-1-.1h0Z"
					/>
					<path
						className="ff"
						d="M1013.75,535.5c-2.2,0-4.4-1.4-4.4-4.2s2.3-4.2,4.4-4.2c1.1,0,2,.3,2.7,.6l-.3,1.6c-.5-.3-1.3-.6-2-.6-1.4,0-2.7,.9-2.7,2.5s1.1,2.5,2.7,2.5c.5,0,.8,0,1.1-.3v-1.3h-1.4v-1.6h3.1v3.8c-.8,1-1.8,1.2-3.2,1.2Z"
					/>
					<path
						className="ff"
						d="M1018.05,535.3v-8h4.5v1.6h-2.7v1.6h2.2v1.6h-2.2v1.6h3.1v1.6h-4.9Z"
					/>
				</g>
				<g>
					<g>
						<circle className="ff" cx="1000.35" cy="553" r="7.8" />
						<path
							className="fp"
							d="M1000.35,561.7c-4.8,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6,8.6,3.9,8.6,8.6-3.9,8.6-8.6,8.6Zm0-15.7c-3.9,0-7,3.1-7,7s3.1,7,7,7,7-3.1,7-7-3.1-7-7-7Z"
						/>
					</g>
					<path
						className="fp"
						d="M999.85,556.4c-.5,0-.9-.2-1.3-.2l-.2-1.3c.3,.2,.8,.3,1.1,.3,.6,0,.9-.3,.9-.9,0-.5-.5-.9-1.1-.9-.5,0-.6,0-.9,.2l.2-3.3h3l-.3,1.1h-1.4v.9h.2c.9,0,1.9,.6,1.9,1.9,.3,1.4-.5,2.2-2.1,2.2Z"
					/>
				</g>
			</g>
			<g id="lounge">
				<g>
					<polygon
						className="fq"
						points="570.65 531.7 416.25 531.7 416.05 574.2 570.45 574.2 570.65 531.7"
					/>
					<path
						className="fp"
						d="M571.25,575h-156l.2-44.1h156l-.2,44.1Zm-154.4-1.5h152.9l.2-41h-152.9l-.2,41Z"
					/>
				</g>
				<g>
					<path className="ff" d="M469.35,560.8v-8h1.9v6.4h3v1.6h-4.9Z" />
					<path
						className="ff"
						d="M478.75,561c-2.2,0-4.4-1.6-4.4-4.2s2-4.2,4.4-4.2c2.2,0,4.2,1.6,4.2,4.2s-2,4.2-4.2,4.2Zm0-6.6c-1.3,0-2.3,.9-2.3,2.5s1.1,2.5,2.3,2.5c1.3,0,2.3-.9,2.3-2.5s-1.1-2.5-2.3-2.5Z"
					/>
					<path
						className="ff"
						d="M487.45,561c-1.9,0-3.4-1.1-3.4-3v-5.2h1.9v5c0,.9,.6,1.6,1.6,1.6s1.6-.6,1.6-1.6v-5h1.9v5.2c-.1,1.9-1.7,3-3.6,3Z"
					/>
					<path
						className="ff"
						d="M498.75,561l-3.1-3.4c-.5-.6-1.1-1.3-1.6-1.7h0v5.1h-1.9v-8h1.6l2.8,3c.3,.5,.9,1.1,1.3,1.6h0v-4.6h1.9v8.1l-1-.1h0Z"
					/>
					<path
						className="ff"
						d="M505.35,561c-2.2,0-4.4-1.4-4.4-4.2s2.3-4.2,4.4-4.2c1.1,0,2,.3,2.7,.6l-.3,1.6c-.5-.3-1.3-.6-2-.6-1.4,0-2.7,.9-2.7,2.5s1.1,2.5,2.7,2.5c.5,0,.8,0,1.1-.3v-1.4h-1.7v-1.6h3.1v3.8c-.7,.9-1.7,1.3-2.9,1.3Z"
					/>
					<path
						className="ff"
						d="M509.35,560.8v-8h4.5v1.6h-2.7v1.6h2.2v1.6h-2.2v1.6h3.1v1.6h-4.9Z"
					/>
				</g>
				<g>
					<g>
						<circle className="ff" cx="529.25" cy="556.6" r="7.8" />
						<path
							className="fp"
							d="M529.25,565.3c-4.8,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6,8.6,3.9,8.6,8.6-3.9,8.6-8.6,8.6Zm0-15.7c-3.9,0-7,3.1-7,7s3.1,7,7,7,7-3.1,7-7-3.1-7-7-7Z"
						/>
					</g>
					<path
						className="fp"
						d="M530.65,558.5v1.4h-1.3v-1.4h-2.3l-.2-1,2.7-3.6h1.1v3.4h.6v1.1l-.6,.1h0Zm-1.3-2.7c-.2,.2-.3,.5-.3,.6l-.8,1.1h1.3v-1.1c-.2-.3-.2-.4-.2-.6h0Z"
					/>
				</g>
			</g>
			<g id="lounge">
				<g>
					<path
						className="fq"
						d="M615.85,194.1c-17.2,0-31.1,13.9-31.1,31.1v-.9h66.7v-30.2h-35.6Z"
					/>
					<path
						className="fp"
						d="M652.05,225.1h-68.3v.2c0-17.5,14.2-31.9,31.9-31.9h36.4v31.7h0Zm-66.7-1.6h65.2v-28.6h-34.7c-16.7,0-30.3,13.6-30.3,30.3l-.2-1.7Z"
					/>
				</g>
				<g>
					<path
						className="ff"
						d="M595.95,213.3v-5.9h1.4v4.8h2.2v1.3h-3.6v-.2h0Z"
					/>
					<path
						className="ff"
						d="M603.05,213.5c-1.7,0-3.3-1.3-3.3-3.1,0-1.9,1.6-3.1,3.3-3.1s3.3,1.3,3.3,3.1c-.1,1.8-1.6,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.8-1.9-1.7-1.9Z"
					/>
					<path
						className="ff"
						d="M609.55,213.5c-1.4,0-2.7-.8-2.7-2.3v-3.9h1.4v3.8c0,.8,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-3.8h1.4v3.9c.4,1.5-.7,2.3-2.3,2.3Z"
					/>
					<path
						className="ff"
						d="M618.05,213.5l-2.3-2.5c-.3-.5-.8-.9-1.1-1.3h0v3.8h-1.4v-6h1.3l2,2.2c.3,.3,.8,.8,.9,1.1h0v-3.3h1.4v6.1l-.8-.1h0Z"
					/>
					<path
						className="ff"
						d="M622.85,213.5c-1.7,0-3.3-1.1-3.3-3.1s1.7-3.1,3.3-3.1c.8,0,1.6,.2,1.9,.5l-.3,1.3c-.3-.3-.9-.5-1.6-.5-1.1,0-2,.8-2,1.9s.9,1.9,1.9,1.9c.3,0,.6,0,.8-.2v-.9h-1.1v-1.1h2.3v2.8c-.2,.3-.8,.5-1.9,.5Z"
					/>
					<path
						className="ff"
						d="M625.95,213.3v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
				</g>
				<g>
					<g>
						<circle className="ff" cx="639.75" cy="210.8" r="7.8" />
						<path
							className="fp"
							d="M639.75,219.4c-4.8,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6,8.6,3.9,8.6,8.6-3.8,8.6-8.6,8.6Zm0-15.6c-3.9,0-7,3.1-7,7s3.1,7,7,7,7-3.1,7-7-2.9-7-7-7Z"
						/>
					</g>
					<path
						className="fp"
						d="M639.25,214.3c-.3,0-.8,0-1.1-.2l-.2-1.3c.3,.2,.6,.3,.9,.3,.6,0,1.1-.3,1.1-.8s-.5-.8-.9-.8h-.2l-.2-.9c.5-.2,.9-.3,.9-.8,0-.3-.3-.5-.6-.5s-.6,.2-.8,.3l-.3-1.1c.3-.2,.8-.3,1.3-.3,1.1,0,1.9,.6,1.9,1.4,0,.6-.5,1.1-.8,1.1,.6,.2,1.3,.8,1.3,1.7,.1,1.1-.9,1.9-2.3,1.9Z"
					/>
				</g>
			</g>
			<g id="lounge">
				<g>
					<polygon
						className="fq"
						points="76.05 221.9 32.95 330.6 153.95 379.2 196.65 271.8 76.05 221.9"
					/>
					<path
						className="fp"
						d="M154.45,380.1l-.8-.3-121.8-48.8,43.6-110.2,.8,.3,121.1,50.2-42.9,108.8Zm-120.6-50l119.6,48,42-106-119-49.2-42.6,107.2Z"
					/>
				</g>
				<g>
					<path
						className="ff"
						d="M101.15,294.5l3.1-7.3,1.7,.8-2.5,5.9,2.8,1.1-.6,1.4-4.5-1.9Z"
					/>
					<path
						className="ff"
						d="M109.75,298.4c-2-.8-3.3-3.1-2.3-5.5,.9-2.3,3.6-3.1,5.6-2.2,2,.8,3.3,3.1,2.3,5.5-1.1,2.2-3.6,2.9-5.6,2.2Zm2.5-6.3c-1.1-.5-2.5,0-3.1,1.4s.2,2.7,1.3,3.1c1.1,.5,2.5,0,3.1-1.4,.4-1.2-.3-2.6-1.3-3.1Z"
					/>
					<path
						className="ff"
						d="M117.85,301.6c-1.7-.8-2.8-2.3-2-4.1l2-4.7,1.7,.8-1.9,4.5c-.3,.9,0,1.6,.8,2,.8,.3,1.6,.2,2-.8l1.9-4.5,1.7,.8-2,4.7c-.6,1.7-2.5,2.1-4.2,1.3Z"
					/>
					<path
						className="ff"
						d="M128.35,305.9l-1.6-4.4c-.3-.8-.5-1.6-.8-2.2h0c-.2,.5-.5,1.1-.6,1.6l-1.3,3.1-1.7-.8,3.1-7.3,1.4,.6,1.4,3.8c.2,.5,.5,1.4,.6,1.9h0c.2-.5,.3-.9,.5-1.4l1.1-2.8,1.7,.8-3.1,7.5-.7-.4Z"
					/>
					<path
						className="ff"
						d="M134.25,308.5c-2-.8-3.6-3-2.5-5.6,1.1-2.5,3.8-3,5.6-2.2,.9,.5,1.7,1.1,2.2,1.6l-.9,1.4c-.3-.5-.9-.9-1.7-1.3-1.4-.6-2.8-.2-3.4,1.4-.6,1.4,.2,2.7,1.4,3.3,.5,.2,.8,.3,1.1,.2l.5-1.1-1.3-.5,.6-1.4,3,1.3-1.4,3.4c-1,0-2.1,0-3.2-.5Z"
					/>
					<path
						className="ff"
						d="M138.15,309.9l3.1-7.3,4.2,1.7-.6,1.4-2.5-1.1-.6,1.4,2,.8-.6,1.6-2-.8-.6,1.4,2.8,1.1-.6,1.4-4.6-1.6Z"
					/>
				</g>
				<g>
					<g>
						<circle className="ff" cx="115.35" cy="316.2" r="7.8" />
						<path
							className="fp"
							d="M115.35,324.8c-4.7,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.8h0c4.7,0,8.6,3.9,8.6,8.6h0c.1,4.9-3.8,8.8-8.6,8.8h0Zm0-15.8h0c-3.9,0-7,3.1-7,7.2s3.1,7,7,7h0c3.9,0,7-3.1,7-7.2h0c0-3.9-3.1-7-7-7Z"
						/>
					</g>
					<path
						className="fp"
						d="M114.85,319.5v-4.8l-.9,.2,.3-1.3,2-.2v6.1h-1.4Z"
					/>
				</g>
			</g>
			<polygon
				className="fh"
				points="784.45 780.4 788.05 766 791.55 767 789.05 758.2 782.75 764.6 786.05 765.6 782.45 779.9 784.45 780.4"
			/>
			<polygon
				className="fh"
				points="760.85 786.7 746.55 783.1 747.25 779.6 738.65 782.1 745.05 788.5 746.05 785.1 760.25 788.7 760.85 786.7"
			/>
			<polygon
				className="fh"
				points="898.15 825.6 912.35 829.2 911.55 832.5 920.35 830.1 913.75 823.7 912.95 827.2 898.55 823.4 898.15 825.6"
			/>
			<polygon
				className="fh"
				points="884.85 806.5 888.45 792.1 891.85 792.9 889.35 784.2 883.15 790.7 886.35 791.5 882.85 805.9 884.85 806.5"
			/>
			<g id="imecDesk">
				<g>
					<polygon
						className="fm"
						points="796.55 793.7 863.15 810.9 858.45 827.9 791.95 810.7 796.55 793.7"
					/>
					<path
						className="fe"
						d="M858.85,828.9l-67.8-17.5,5-18.6,68.2,17.7-5.4,18.4Zm-65.9-18.6l64.9,16.7,4.4-15.6-65-16.9-4.3,15.8Z"
					/>
				</g>
				<g>
					<path
						className="ff"
						d="M809.35,809.6l1.3-4.8,1.3,.3-1.3,4.8-1.3-.3Z"
					/>
					<path
						className="ff"
						d="M815.75,811.2l.3-1.9c0-.3,.2-.6,.2-.9h0c-.2,.3-.5,.6-.6,.8l-1.4,1.6-.5-.2-.5-2c0-.3-.2-.6-.2-.9h0c-.2,.3-.2,.6-.3,.9l-.6,1.7-1.1-.3,1.7-4.7,.9,.3,.5,2.3c0,.3,.2,.8,.2,1.1h0c.2-.3,.5-.6,.8-.9l1.6-1.7,.9,.3-.8,5-1.1-.5Z"
					/>
					<path
						className="ff"
						d="M817.65,811.7l1.3-4.8,2.8,.8-.3,.9-1.6-.5-.3,.9,1.4,.3-.3,.9-1.4-.3-.3,.9,1.9,.5-.3,.9-2.9-.5Z"
					/>
					<path
						className="ff"
						d="M825.55,810c-.2-.2-.5-.5-.9-.5-.8-.2-1.7,.2-1.9,1.1-.2,.9,.3,1.7,1.3,1.9,.5,.2,.8,.2,1.1,0l-.3,.9c-.3,0-.6,0-1.1-.2-1.3-.3-2.3-1.6-1.9-3.1,.5-1.6,2-2.2,3.3-1.9,.6,.2,1.1,.5,1.3,.6l-.9,1.2Z"
					/>
					<path
						className="ff"
						d="M828.75,814.6l-1.6-.5,1.3-4.8,1.6,.5c1.4,.3,2.3,1.6,2,3.1-.4,1.4-1.9,2.1-3.3,1.7Zm.9-3.9l-.3-.2-.8,3,.3,.2c.8,.2,1.7-.2,1.9-1.1,.3-.9-.3-1.7-1.1-1.9Z"
					/>
					<path
						className="ff"
						d="M832.05,815.4l1.3-4.8,2.8,.8-.3,.9-1.6-.5-.3,.9,1.4,.3-.3,.9-1.4-.3-.3,.9,1.9,.5-.3,.9-2.9-.5Z"
					/>
					<path
						className="ff"
						d="M836.65,816.8c-.5-.2-1.1-.5-1.3-.6l.2-1.1c.3,.3,.8,.6,1.3,.8s.8,0,.8-.3,0-.5-.5-.8c-.9-.5-1.3-1.1-.9-1.9,.2-.8,.9-1.3,2-1.1,.6,.2,.9,.5,1.1,.6l-.5,.9c-.2-.2-.5-.5-.8-.5-.5-.2-.6,0-.8,.3,0,.3,.2,.5,.5,.6,.8,.5,1.3,1.1,1.1,2-.1,1-.9,1.5-2.2,1.1Z"
					/>
					<path
						className="ff"
						d="M841.85,818.1l-.9-2.3h0l-.5,2-1.3-.3,1.3-4.8,1.3,.3-.5,2h0l2-1.7,1.3,.3-2.3,1.9,1.1,3-1.5-.4Z"
					/>
				</g>
			</g>
			<path
				className="ft"
				d="M904.55,424.2c-.5,0-.8-.3-.8-.8v-157.4c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v157.4c0,.5-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M935.65,424.2c-.5,0-.8-.3-.8-.8v-157.4c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v157.4c0,.5-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M1000.15,731.3h-80c-.5,0-.8-.3-.8-.8v-246.8c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v245.9h79.2c.5,0,.8,.3,.8,.8s-.3,.9-.8,.9Z"
			/>
			<path
				className="ft"
				d="M1000.35,726.6h-75.5c-.5,0-.8-.3-.8-.8v-242.1c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v241.2h74.7c.5,0,.8,.3,.8,.8s-.3,.9-.8,.9Z"
			/>
			<path
				className="ft"
				d="M1000.35,722h-70.8c-.5,0-.8-.3-.8-.8v-237.5c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v236.5h70c.5,0,.8,.3,.8,.8s-.3,1-.8,1Z"
			/>
			<path
				className="ft"
				d="M1000.35,717.3h-66.1c-.5,0-.8-.3-.8-.8v-232.8c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v231.8h65.3c.5,0,.8,.3,.8,.8s-.3,1-.8,1Z"
			/>
			<path
				className="ft"
				d="M1000.35,712.6h-61.4c-.5,0-.8-.3-.8-.8v-228.1c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v227.1h60.6c.5,0,.8,.3,.8,.8s-.3,1-.8,1Z"
			/>
			<path
				className="ft"
				d="M1000.35,707.9h-56.7c-.5,0-.8-.3-.8-.8v-223.4c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v222.4h56c.5,0,.8,.3,.8,.8s-.4,1-.9,1Z"
			/>
			<path
				className="ft"
				d="M1000.35,703.2h-52.1c-.5,0-.8-.3-.8-.8v-218.7c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v217.8h51.3c.5,0,.8,.3,.8,.8,0,.4-.3,.9-.8,.9Z"
			/>
			<path
				className="ft"
				d="M1000.35,698.5h-47.4c-.5,0-.8-.3-.8-.8v-213.2h-32c-.5,0-.8-.3-.8-.8v-192.2c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v191.5h32c.5,0,.8,.3,.8,.8v213h46.6c.5,0,.8,.3,.8,.8s-.3,.9-.8,.9Z"
			/>
			<g>
				<path
					className="ft"
					d="M978.45,358.1c-1.7,0-3-1.4-3-3v-46.1c0-1.7,1.4-3,3-3s3,1.4,3,3v46.1c.1,1.6-1.3,3-3,3Zm0-50.7c-.8,0-1.4,.6-1.4,1.4v46.1c0,.8,.6,1.4,1.4,1.4s1.4-.6,1.4-1.4v-46.1c.2-.7-.4-1.4-1.4-1.4Z"
				/>
				<path
					className="ft"
					d="M976.25,312.6h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,315.7h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,318.8h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,321.8h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,324.9h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,328.1h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8,0,.4-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,331.2h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,334.2h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8,0,.4-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,337.3h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,340.4h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,343.4h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,346.5h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,349.6h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,352.8h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h26.7c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M976.25,355.9h-26.7c-.2,0-.5-.2-.6-.2-.2,0-.2-.3-.2-.6v-46.6c0-8,3.1-15.3,8.8-20.9,5.6-5.6,13.1-8.8,20.9-8.8,16.4,0,29.7,13.3,29.7,29.7v3.3c0,.2,0,.5-.2,.6-.2,.2-.3,.3-.6,.3h-26.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h25.9v-2.5c0-15.5-12.7-28.1-28.1-28.1-7.5,0-14.5,3-19.9,8.3-5.3,5.3-8.3,12.3-8.3,19.9v45.8h25.9c.5,0,.8,.3,.8,.8s-.2,.6-.7,.6Z"
				/>
			</g>
			<g>
				<path
					className="ft"
					d="M1002.55,736.5c-1.7,0-3-1.4-3-3v-46.1c0-1.7,1.4-3,3-3s3,1.4,3,3v46.1c0,1.6-1.3,3-3,3Zm0-50.6c-.8,0-1.4,.6-1.4,1.4v46.1c0,.8,.6,1.4,1.4,1.4s1.4-.6,1.4-1.4v-46c0-.8-.6-1.5-1.4-1.5Z"
				/>
				<path
					className="ft"
					d="M1047.75,731.3h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,728.2h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,725.1h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,722.1h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,719h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8s-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,715.9h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,712.7h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,709.8h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,706.6h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,703.5h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,700.5h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,697.4h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,694.3h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1047.75,691.2h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.5,0,.8,.3,.8,.8-.1,.5-.5,.8-.8,.8Z"
				/>
				<path
					className="ft"
					d="M1003.35,780.6c-24.9,0-45-20.2-45-45l-.2-5.2c0-.2,0-.5,.2-.6,.2-.2,.3-.3,.6-.3h41.1c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8h-40.2l.2,4.4c0,23.9,19.5,43.5,43.5,43.5,11.6,0,22.5-4.5,30.6-12.8,8.3-8.3,12.8-19.1,12.8-30.6v-47.5h-42.2c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43c.2,0,.5,.2,.6,.2,.2,0,.2,.3,.2,.6v48.3c0,12-4.7,23.3-13.3,31.9-8.6,8.4-19.9,13.1-31.9,13.1Z"
				/>
			</g>
			<path
				className="ft"
				d="M478.15,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M481.05,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M484.25,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c-.1,.4-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M487.35,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M490.35,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c-.1,.4-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M493.45,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M496.55,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M499.55,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M502.65,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M505.75,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M508.95,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c-.1,.4-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M511.85,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c0,.4-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M515.05,704.5c-.5,0-.8-.3-.8-.8v-27c0-.5,.3-.8,.8-.8s.8,.3,.8,.8v27c-.1,.4-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M1053.65,730.2h-6.1c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h6.1c.5,0,.8,.3,.8,.8s-.3,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M1053.65,697.4h-6.1c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h6.1c.5,0,.8,.3,.8,.8,0,.5-.3,.8-.8,.8Z"
			/>
			<path
				className="fg"
				d="M715.25,194.9h-18.6c-.5,0-.8-.3-.8-.8v-9.1c0-.5,.3-.8,.8-.8h18.6c.5,0,.8,.3,.8,.8v9.1c0,.5-.3,.8-.8,.8Zm-17.7-1.6h16.9v-7.5h-17l.1,7.5h0Z"
			/>
			<path
				className="fg"
				d="M780.25,194.9h-18.6c-.5,0-.8-.3-.8-.8v-9.1c0-.5,.3-.8,.8-.8h18.6c.5,0,.8,.3,.8,.8v9.1c0,.5-.3,.8-.8,.8Zm-17.8-1.6h17v-7.5h-17v7.5Z"
			/>
			<path
				className="ft"
				d="M506.25,673c-.5,0-.8-.3-.8-.8v-37.4h-61.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h62.5c.5,0,.8,.3,.8,.8v38.1c0,.6-.5,.9-.8,.9Z"
			/>
			<path
				className="ft"
				d="M501.55,673c-.5,0-.8-.3-.8-.8v-32.7h-57.1c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h57.8c.5,0,.8,.3,.8,.8v33.4c.1,.6-.4,.9-.7,.9Z"
			/>
			<path
				className="ft"
				d="M496.85,673c-.5,0-.8-.3-.8-.8v-28h-52.4c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h53.2c.5,0,.8,.3,.8,.8v28.8c0,.5-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M492.15,673c-.5,0-.8-.3-.8-.8v-23.3h-47.7c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h48.5c.5,0,.8,.3,.8,.8v24.1c0,.5-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M487.45,673c-.5,0-.8-.3-.8-.8v-18.6h-43c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h43.8c.5,0,.8,.3,.8,.8v19.4c0,.5-.4,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M482.85,673c-.5,0-.8-.3-.8-.8v-13.9h-38.3c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h39.1c.5,0,.8,.3,.8,.8v14.7c-.1,.5-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M478.15,673c-.5,0-.8-.3-.8-.8v-9.2h-33.6c-.5,0-.8-.3-.8-.8s.3-.8,.8-.8h34.4c.5,0,.8,.3,.8,.8v10c0,.5-.5,.8-.8,.8Z"
			/>
			<path
				className="ft"
				d="M515.15,677.4h-37.2c-1.7,0-3-1.4-3-3s1.4-3,3-3h37.2c1.7,0,3,1.4,3,3s-1.4,3-3,3Zm-37.2-4.4c-.8,0-1.4,.6-1.4,1.4s.6,1.4,1.4,1.4h37.2c.8,0,1.4-.6,1.4-1.4s-.6-1.4-1.4-1.4h-37.2Z"
			/>
			<path
				className="fg"
				d="M570.65,451.5h-18.6c-.5,0-.8-.3-.8-.8v-9.1c0-.5,.3-.8,.8-.8h18.6c.5,0,.8,.3,.8,.8v9.1c0,.4-.3,.8-.8,.8Zm-17.7-1.5h17v-7.5h-17v7.5Z"
			/>
			<path
				className="fg"
				d="M570.65,488.7h-18.6c-.5,0-.8-.3-.8-.8v-9.1c0-.5,.3-.8,.8-.8h18.6c.5,0,.8,.3,.8,.8v9.1c0,.4-.3,.8-.8,.8Zm-17.7-1.5h17v-7.5h-17v7.5Z"
			/>
			<path
				className="fg"
				d="M236.75,431.2h-.3l-8.3-3.4h0l-71.9-29.5c-.5-.2-.6-.6-.5-1.1l3.4-8.3h0l1.9-4.7c.2-.5,.6-.6,1.1-.5l8.3,3.4c.2,.2,.3,.2,.5,.5,.2,.2,.2,.5,0,.6l-1.7,4.1,62.2,25.6,1.7-4.1c.2-.5,.6-.6,1.1-.5l8.3,3.4c.2,.2,.3,.2,.5,.5,.2,.2,.2,.5,0,.6l-5.3,13.1c-.3,.2-.7,.3-1,.3Zm-7.9-4.8l7.5,3.1,4.8-11.6-6.9-2.8-1.7,4.1c-.2,.5-.6,.6-1.1,.5l-63.6-26.1c-.5-.2-.6-.6-.5-1.1l1.7-4.1-6.9-2.8-1.7,4.1h0l-3.1,7.5,71.5,29.2h0Z"
			/>
			<path
				className="fg"
				d="M570.65,532.5h-57.8c-.5,0-.8-.3-.8-.8v-18.6c0-.5,.3-.8,.8-.8h9.1c.5,0,.8,.3,.8,.8v8.8h28.6v-3.3c0-.5,.3-.8,.8-.8h18.6c.5,0,.8,.3,.8,.8v13c-.1,.6-.4,.9-.9,.9Zm-56.9-1.5h56.3v-11.5h-17v3.3c0,.5-.3,.8-.8,.8h-30.2c-.5,0-.8-.3-.8-.8v-8.9h-7.5v17.1h0Z"
			/>
			<path
				className="fg"
				d="M468.15,532.5h-41.3l-98.8-38.5h0l-8.4-3.3c-.2,0-.3-.2-.5-.5-.2-.2-.2-.5,0-.6l8.3-21.1-63.5-26c-.2-.2-.3-.2-.5-.5-.2-.2-.2-.5,0-.6l3.4-8.3h0l1.9-4.7c.2-.5,.6-.6,1.1-.5l8.3,3.4c.2,.2,.3,.2,.5,.5,.2,.2,.2,.5,0,.6l-1.7,4.1,55,22.7h.2l8.3,3.4c.5,.2,.6,.6,.5,.9l-8.1,20.9,96.3,37.5h29.2v-8.8c0-.5,.3-.8,.8-.8h9.1c.5,0,.8,.3,.8,.8v18.6c-.2,.5-.5,.8-.9,.8Zm-40.8-1.5h40v-17h-7.5v8.8c0,.5-.3,.8-.8,.8h-30.5l-97.1-37.8c-.5-.2-.6-.6-.5-.9l8.1-20.9-7.7-3.1h-.2l-55.6-22.8c-.5-.2-.6-.6-.5-1.1l1.7-4.1-6.9-2.8-1.7,4.1h0l-3.1,7.5,63.1,25.9h.3c.5,.2,.6,.6,.5,.9h0l-8.3,21.1,7.7,3h0l99,38.4Z"
			/>
			<path
				className="fg"
				d="M865.45,801.8h0l-66.6-17.5c-.2,0-.3-.2-.5-.3-.2-.2-.2-.5-.2-.6l2.3-8.8c.2-.5,.5-.6,.9-.6l66.4,17.5c.2,0,.3,.2,.5,.3,.2,.2,.2,.5,0,.6l-2.5,8.6c.3,.5,0,.8-.3,.8Zm-65.3-18.7l64.9,17,2-7.2-65-17-1.9,7.2Z"
			/>
			<path
				className="fg"
				d="M909.65,816.4h0l-8.8-2.5c-.5-.2-.6-.5-.5-.9l.5-1.7-2-.5c-.2,0-.3-.2-.5-.3-.2-.2-.2-.5,0-.6l2.3-8.8c.2-.5,.5-.6,.9-.6l2.5,.6h.3l8.8,2.3c.5,.2,.6,.5,.6,.9l-3,11.4c0,.2-.2,.3-.3,.5-.5,.2-.6,.2-.8,.2Zm-7.6-3.8l7.2,2,2.7-9.8-7.7-2h-.3l-2-.5-1.9,7.2,2,.5c.2,0,.3,.2,.5,.3,.2,.2,.2,.5,.2,.6l-.7,1.7Z"
			/>
			<path
				className="fg"
				d="M763.65,777.9h0l-8.9-2.3c-.5-.2-.6-.5-.6-.9l.6-2.5v-.3l2.3-8.8c.2-.5,.5-.6,.9-.6l11.4,3c.2,0,.3,.2,.5,.3,.2,.2,.2,.5,0,.6l-2.5,8.6c-.2,.5-.5,.6-.9,.5l-1.7-.5-.5,2c0,.2-.2,.3-.3,.5-.1,.4-.3,.4-.3,.4Zm-7.8-3.6l7.2,1.9,.5-2c0-.2,.2-.3,.3-.5,.2-.2,.5-.2,.6-.2l1.7,.5,2-7.2-9.8-2.7-2,7.7v.2l-.5,2.3Z"
			/>
			<g className="fl">
				<rect className="ff" x="459.35" y="653.8" width="86" height="21.3" />
			</g>
			<g id="breakoutMarble">
				<g>
					<path
						className="fn"
						d="M1001.25,362.9h-2.2v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6,0,1.2-1,1.8-2.1,1.8Zm-.4-4.8h-.5v1.3h.5c.3,0,.6-.2,.6-.6,0-.6-.3-.7-.6-.7Zm.3,2.3h-.6v1.6h.6c.5,0,.9-.2,.9-.8-.1-.6-.6-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M1007.55,362.9l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.7h-.6v1.4h.6c.3,0,.8-.2,.8-.6,0-.6-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M1009.45,362.9v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M1017.65,362.9l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.2-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1022.85,362.9l-1.7-2.5h0v2.5h-1.4v-5.9h1.4v2.5h0l1.9-2.5h1.6l-2,3,2.2,3-2-.1h0Z"
					/>
					<path
						className="fn"
						d="M1027.85,363.1c-1.7,0-3.3-1.3-3.3-3.1s1.6-3.1,3.3-3.1,3.3,1.3,3.3,3.1-1.7,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.9-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M1034.45,363.1c-1.4,0-2.7-.8-2.7-2.3v-3.9h1.4v3.8c0,.8,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-3.8h1.4v3.9c.3,1.5-.9,2.3-2.3,2.3Z"
					/>
					<path
						className="fn"
						d="M1040.65,358.2v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path
						className="fn"
						d="M1004.55,374.2l-.2-2.2v-1.1h0c-.2,.3-.3,.8-.5,1.1l-1.1,2.2h-.6l-1.1-2.2c-.2-.3-.3-.8-.5-1.1h0v1.1l-.2,2.2h-1.6l.5-5.9h1.3l1.3,2.5c.2,.3,.5,.9,.6,1.3h0c.2-.5,.3-.9,.6-1.3l1.3-2.5h1.1l.5,5.9h-1.4Z"
					/>
					<path
						className="fn"
						d="M1010.65,374.2l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.2-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1016.15,374.2l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.7h-.6v1.4h.6c.3,0,.8-.2,.8-.6,0-.7-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M1020.15,374.2h-2.2v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6,.1,1.1-.8,1.8-2.1,1.8Zm-.4-4.9h-.5v1.3h.5c.3,0,.6-.2,.6-.6,.2-.5-.2-.7-.6-.7Zm.3,2.4h-.6v1.6h.6c.5,0,.9-.2,.9-.8s-.4-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M1023.15,374.2v-5.9h1.4v4.8h2.2v1.3l-3.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M1027.35,374.2v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
				</g>
				<polygon
					className="fn"
					points="1048.65 362 1079.45 362 1079.45 369 1095.85 359.6 1079.45 350.3 1079.45 357.4 1048.65 357.4 1048.65 362"
				/>
			</g>
			<g id="breakoutGorillaMeeting">
				<g>
					<path
						className="fn"
						d="M463.55,662.6h-2.3v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6,.1,1.1-.9,1.8-2,1.8Zm-.4-4.9h-.5v1.3h.5c.3,0,.6-.2,.6-.6,0-.5-.3-.7-.6-.7Zm.1,2.2h-.6v1.6h.6c.5,0,.9-.3,.9-.8,.1-.5-.4-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M469.65,662.6l-1.6-2.3h-.2v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.9-.3h0Zm-1.4-4.9h-.6v1.4h.6c.3,0,.8-.2,.8-.6,0-.5-.3-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M471.75,662.6v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M479.85,662.6l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.3-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M485.15,662.6l-1.7-2.5h0v2.5h-1.4v-5.9h1.4v2.5h0l1.9-2.5h1.6l-2,3,2.2,3-2-.1h0Z"
					/>
					<path
						className="fn"
						d="M489.95,662.7c-1.7,0-3.3-1.3-3.3-3.1s1.6-3.1,3.3-3.1,3.3,1.3,3.3,3.1-1.5,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.7-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M496.55,662.7c-1.4,0-2.7-.8-2.7-2.3v-3.9h1.4v3.8c0,.8,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-3.8h1.4v3.9c.4,1.5-.7,2.3-2.3,2.3Z"
					/>
					<path
						className="fn"
						d="M502.95,657.9v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path
						className="fn"
						d="M510.45,662.7c-1.7,0-3.3-1.1-3.3-3.1s1.7-3.1,3.3-3.1c.8,0,1.6,.2,1.9,.5l-.3,1.3c-.3-.3-.9-.5-1.6-.5-1.1,0-2,.8-2,1.9s.9,1.9,1.9,1.9c.3,0,.6,0,.8-.2v-.9h-1.1v-1.1h2.3v2.8c-.2,.4-.9,.5-1.9,.5Z"
					/>
					<path
						className="fn"
						d="M516.55,662.7c-1.7,0-3.3-1.3-3.3-3.1s1.6-3.1,3.3-3.1,3.3,1.3,3.3,3.1-1.6,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.7-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M524.05,662.6l-1.6-2.3h-.3v2.3h-1.6v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.6-.3h0Zm-1.5-4.9h-.7v1.4h.6c.3,0,.8-.2,.8-.6,0-.5-.3-.8-.7-.8Z"
					/>
					<path className="fn" d="M525.95,662.6v-5.9h1.4v5.9h-1.4Z" />
					<path
						className="fn"
						d="M528.45,662.6v-5.9h1.4v4.8h2.2v1.3l-3.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M532.85,662.6v-5.9h1.4v4.8h2.2v1.3l-3.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M540.95,662.6l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.2-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M466.85,673.8l-.2-2.2v-1.1h0c-.2,.3-.3,.8-.5,1.1l-1.1,2.2h-.8l-1.1-2.2c-.2-.3-.3-.8-.5-1.1h0v1.1l-.2,2.2h-1.4l.5-5.9h1.3l1.3,2.5c.2,.3,.5,.9,.6,1.3h0c.2-.5,.3-.9,.6-1.3l1.3-2.5h1.1l.5,5.9h-1.4Z"
					/>
					<path
						className="fn"
						d="M469.05,673.8v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M473.25,673.8v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M480.35,669.1v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path className="fn" d="M482.65,673.8v-5.9h1.4v5.9h-1.4Z" />
					<path
						className="fn"
						d="M489.95,674l-2.3-2.5c-.3-.5-.8-.9-1.1-1.3h0v3.8h-1.4v-5.9h1.1l2,2.2c.3,.3,.8,.8,.9,1.1h0v-3.3h1.4v6.1l-.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M494.85,674c-1.7,0-3.3-1.1-3.3-3.1s1.7-3.1,3.3-3.1c.8,0,1.6,.2,1.9,.5l-.3,1.3c-.3-.3-.9-.5-1.6-.5-1.1,0-2,.8-2,1.9s.9,1.9,1.9,1.9c.3,0,.6,0,.8-.2v-.9h-1.1v-1.3h2.3v2.8c-.2,.5-.8,.7-1.9,.7Z"
					/>
					<path
						className="fn"
						d="M503.55,673.8l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.8h-.6v1.4h.6c.3,0,.8-.2,.8-.6-.1-.5-.4-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M508.15,674c-1.7,0-3.3-1.3-3.3-3.1s1.6-3.1,3.3-3.1,3.3,1.3,3.3,3.1-1.6,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.8-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M515.35,674c-1.7,0-3.3-1.3-3.3-3.1s1.6-3.1,3.3-3.1,3.3,1.3,3.3,3.1-1.8,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9-.9-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M524.65,673.8l-.2-2.2v-1.1h0c-.2,.3-.3,.8-.5,1.1l-1.1,2.2h-.6l-1.1-2.2c-.2-.3-.3-.8-.5-1.1h0v1.1l-.2,2.2h-1.6l.5-5.9h1.3l1.3,2.5c.2,.3,.5,.9,.6,1.3h0c.2-.5,.3-.9,.6-1.3l1.3-2.5h1.1l.5,5.9h-1.4Z"
					/>
					<path
						className="fn"
						d="M528.65,674c-.6,0-1.3-.2-1.7-.5l-.2-1.4c.5,.3,1.1,.6,1.7,.6,.5,0,.8-.2,.8-.6,0-.3-.2-.5-.8-.6-1.3-.3-1.7-.9-1.7-1.9s.8-1.7,2-1.7c.6,0,1.3,.2,1.6,.3l-.3,1.1c-.3-.2-.8-.3-1.1-.3-.5,0-.8,.2-.8,.5s.3,.5,.8,.6c1.1,.3,1.9,.9,1.9,2,.1,1.1-.7,1.9-2.2,1.9Z"
					/>
				</g>
				<polygon
					className="fn"
					points="461.85 692.4 492.85 692.4 492.85 699.6 509.05 690.2 492.85 680.8 492.85 687.9 461.85 687.9 461.85 692.4"
				/>
			</g>
			<g id="plenaryBreakoutElisabeth">
				<g>
					<path
						className="fn"
						d="M979.05,743.5h-.9v2.3h-1.4v-5.9h2.3c1.1,0,1.9,.6,1.9,1.9s-.8,1.7-1.9,1.7Zm-.1-2.5h-.6v1.4h.6c.3,0,.8-.2,.8-.6-.2-.6-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M981.75,745.9v-5.9h1.4v4.8h2.2v1.3l-3.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M985.95,745.9v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M995.15,745.9l-2.3-2.5c-.3-.5-.8-.9-1.1-1.3h0v3.8h-1.4v-5.9h1.1l2,2.2c.3,.3,.8,.8,.9,1.1h0v-3.3h1.4v6.1l-.6-.2h0Z"
					/>
					<path
						className="fn"
						d="M1000.65,745.9l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.2-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1006.15,745.9l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.9h-.6v1.4h.6c.3,0,.8-.2,.8-.6,0-.6-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M1010.55,743.2v2.7h-1.4v-2.7l-2.2-3.3h1.6l.9,1.4c.2,.2,.3,.5,.5,.8h0c.2-.3,.3-.5,.5-.8l.9-1.4h1.4l-2.2,3.3Z"
					/>
					<path
						className="fn"
						d="M979.05,757.1h-2.2v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6,0,1-1,1.8-2.1,1.8Zm-.4-5h-.5v1.3h.5c.3,0,.6-.2,.6-.6,0-.5-.3-.7-.6-.7Zm.1,2.4h-.6v1.6h.6c.5,0,.9-.2,.9-.8,.1-.5-.4-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M985.15,757.1l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.8h-.5v1.4h.6c.3,0,.8-.2,.8-.6-.1-.7-.4-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M987.25,757.1v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M995.35,757.1l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.3-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1000.65,757.1l-1.7-2.5h0v2.5h-1.6v-5.9h1.4v2.5h0l1.9-2.5h1.6l-2,3,2.2,3-1.8-.1h0Z"
					/>
					<path
						className="fn"
						d="M1005.55,757.3c-1.7,0-3.3-1.3-3.3-3.1,0-1.9,1.6-3.1,3.3-3.1s3.3,1.3,3.3,3.1c-.1,1.8-1.6,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9c0-1.3-.8-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M1012.05,757.3c-1.4,0-2.7-.8-2.7-2.3v-3.9h1.4v3.8c0,.8,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-3.8h1.4v3.9c.4,1.3-.7,2.3-2.3,2.3Z"
					/>
					<path
						className="fn"
						d="M1018.45,752.3v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path
						className="fn"
						d="M976.75,768.4v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M981.15,768.4v-5.9h1.4v4.8h2.2v1.3l-3.6-.2h0Z"
					/>
					<path className="fn" d="M985.45,768.4v-5.9h1.4v5.9h-1.4Z" />
					<path
						className="fn"
						d="M989.55,768.4c-.6,0-1.3-.2-1.7-.5l-.2-1.4c.5,.3,1.1,.6,1.7,.6,.5,0,.8-.3,.8-.6s-.2-.5-.8-.6c-1.3-.3-1.7-.9-1.7-1.9s.8-1.7,2-1.7c.6,0,1.3,.2,1.6,.3l-.3,1.1c-.3-.2-.8-.3-1.1-.3-.5,0-.8,.2-.8,.5s.3,.5,.8,.6c1.1,.3,1.9,.9,1.9,2,.2,1.3-.6,1.9-2.2,1.9Z"
					/>
					<path
						className="fn"
						d="M996.45,768.4l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.3-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1000.65,768.4h-2.2v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6,.1,1-.8,1.8-2.1,1.8Zm-.5-5h-.5v1.3h.5c.3,0,.6-.2,.6-.6,.2-.6-.1-.7-.6-.7Zm.4,2.3h-.6v1.6h.6c.5,0,.9-.3,.9-.8,0-.5-.5-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M1003.65,768.4v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M1010.55,763.5v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path
						className="fn"
						d="M1016.65,768.4v-2.3h-2.3v2.3h-1.4v-5.9h1.4v2.3h2.3v-2.3h1.4v5.9h-1.4Z"
					/>
				</g>
				<polygon
					className="fn"
					points="1023.95 705.9 1023.95 736.7 1016.75 736.7 1026.15 753.1 1035.65 736.7 1028.45 736.7 1028.45 705.9 1023.95 705.9"
				/>
			</g>
			<g id="breakoutDarwin">
				<g>
					<path
						className="fn"
						d="M988.35,327.3h-2.2v-5.9h2c.9,0,1.7,.6,1.7,1.6,0,.3-.2,.8-.5,.9,.5,.2,1.1,.8,1.1,1.6-.1,1-1,1.8-2.1,1.8Zm-.5-5h-.5v1.3h.5c.3,0,.6-.2,.6-.6s-.3-.7-.6-.7Zm.1,2.3h-.6v1.6h.6c.5,0,.9-.2,.9-.8,.1-.5-.4-.8-.9-.8Z"
					/>
					<path
						className="fn"
						d="M994.55,327.3l-1.6-2.3h-.3v2.3h-1.6v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.6-.3h0Zm-1.4-4.9h-.6v1.4h.6c.3,0,.8-.2,.8-.6-.2-.5-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M996.45,327.3v-5.9h3.4v1.3h-2v1.3h1.7v1.3h-1.7v1.3h2.3v1.3h-3.8l.1-.6h0Z"
					/>
					<path
						className="fn"
						d="M1004.75,327.3l-.5-1.4h-1.9l-.5,1.4h-1.4l2.3-6.1h.9l2.3,6.1h-1.2Zm-1.3-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.1l-.2-1.1Z"
					/>
					<path
						className="fn"
						d="M1009.85,327.3l-1.7-2.5h0v2.5h-1.4v-5.9h1.4v2.5h0l1.9-2.5h1.6l-2,3,2.2,3h-2v-.1Z"
					/>
					<path
						className="fn"
						d="M1014.75,327.4c-1.7,0-3.3-1.3-3.3-3.1,0-1.9,1.6-3.1,3.3-3.1s3.3,1.3,3.3,3.1c0,1.9-1.6,3.1-3.3,3.1Zm0-5c-.9,0-1.7,.8-1.7,1.9s.8,1.9,1.7,1.9,1.7-.8,1.7-1.9c.2-1.1-.8-1.9-1.7-1.9Z"
					/>
					<path
						className="fn"
						d="M1021.45,327.4c-1.4,0-2.7-.8-2.7-2.3v-3.9h1.4v3.8c0,.8,.5,1.1,1.1,1.1s1.1-.5,1.1-1.1v-3.8h1.4v3.9c.2,1.4-.9,2.3-2.3,2.3Z"
					/>
					<path
						className="fn"
						d="M1027.65,322.4v4.8h-1.4v-4.8h-1.7v-1.3h4.8v1.3h-1.7Z"
					/>
					<path
						className="fn"
						d="M988.15,338.5h-2v-5.9h2c1.7,0,3.3,1.1,3.3,3-.2,1.8-1.6,2.9-3.3,2.9Zm-.2-4.8h-.5v3.6h.5c1.1,0,1.9-.6,1.9-1.9,0-1.2-.9-1.7-1.9-1.7Z"
					/>
					<path
						className="fn"
						d="M995.65,338.5l-.5-1.4h-1.9l-.4,1.4h-1.4l2.3-6.1h.9l2.3,6.1c.1,0-1.3,0-1.3,0Zm-1.2-3.6c0-.2-.2-.3-.2-.6h0c0,.2-.2,.5-.2,.6l-.5,1.1h1.3l-.4-1.1Z"
					/>
					<path
						className="fn"
						d="M1001.15,338.5l-1.6-2.3h-.3v2.3h-1.4v-5.9h2.2c1.1,0,1.9,.6,1.9,1.9,0,.6-.5,1.3-.9,1.6l1.9,2.7-1.8-.3h0Zm-1.4-4.8h-.6v1.4h.6c.3,0,.8-.2,.8-.6-.2-.5-.5-.8-.8-.8Z"
					/>
					<path
						className="fn"
						d="M1008.65,338.5h-.9l-.9-2.7c-.2-.5-.3-.8-.5-1.4h0c-.2,.5-.3,.9-.5,1.4l-.9,2.7h-.9l-2-5.9h1.4l.8,2.3c.2,.3,.2,.8,.3,1.3h0c.2-.5,.2-.8,.3-1.3l.8-2.3h1.3l.8,2.3c.2,.3,.2,.8,.3,1.3h0c0-.5,.2-.9,.3-1.3l.8-2.3h1.3l-1.8,5.9Z"
					/>
					<path className="fn" d="M1011.25,338.5v-5.9h1.4v5.9h-1.4Z" />
					<path
						className="fn"
						d="M1018.65,338.5l-2.3-2.5c-.3-.5-.8-.9-1.1-1.3h0v3.8h-1.4v-5.9h1.3l2,2.2c.3,.3,.8,.8,.9,1.1h0v-3.3h1.4v6.1l-.8-.2h0Z"
					/>
				</g>
				<polygon
					className="fn"
					points="965.15 337.4 965.15 306.6 972.35 306.6 962.95 290.2 953.65 306.6 960.65 306.6 960.65 337.4 965.15 337.4"
				/>
			</g>
		</g>
		<g id="fd">
			<path
				className="fg"
				d="M855.17,1027.56l-151.85-39.77,41.2-162.28-217.61-55.48,8.95-41.49v-18.33h-98.9v-29h-32.15l-.34-.1-67.89-19.62-.34-40.48h26.52v-40.15l-43.98-18.79-.3-23.74-11.17-4.32-8.52,19.94-132.13-53.97-42.27,107.73-107.52-40.27,77.73-188.78L0,339.56,57.78,197.65l477.38,191.95v-23h45.1V223.5c0-28.82,29-33.36,37.8-34.07V69.4h-22.8V0h314.9V72.1h-47.58l.77,114.64c7.71,1.68,33.61,9.01,33.61,31.56v41l164-.2v70.8h12.5v5h-17.5v-70.8l-164,.2v-46c0-21.67-31.18-26.98-31.5-27.03l-2.08-.34-.02-2.11-.82-121.72h47.62V5h-304.9v59.4h22.8V194.3h-2.5c-1.44,0-35.3,.4-35.3,29.2v148.1h-45.1v25.4L60.53,204.15,6.51,336.84l94.61,39.1L23.45,564.56l98.08,36.73,42.33-107.87,132.27,54.03,8.48-19.86,18.83,7.28,.3,23.86,44.02,18.81v48.45h-26.48l.26,31.71,63.97,18.49h36.45v29h98.9v23.87l-8.05,37.31,217.79,55.52-41.21,162.32,142.15,37.23,40.69-163.16,92.02,22.31h27.7v-64.2h34.5v-58.3h9.7V380.7h17.2v5h-12.2v377.4h-9.7v58.3h-34.5v64.2h-33.3l-87.78-21.29-40.71,163.25Z"
			/>
		</g>
		<polygon
			className="fg"
			points="124.13 390.66 96.91 379.62 98.79 374.98 121.38 384.14 127.44 369.26 132.07 371.14 124.13 390.66"
		/>
		<rect className="fg" x="436.95" y="626.9" width="5" height="51.8" />
		<rect
			className="fg"
			x="736.71"
			y="807.45"
			width="28.28"
			height="5"
			transform="translate(-211.89 1351.18) rotate(-76.51)"
		/>
		<rect
			className="fg"
			x="883.61"
			y="845.7"
			width="26.88"
			height="5"
			transform="translate(-129.89 1533.42) rotate(-77.11)"
		/>
		<rect className="fg" x="827.75" y="186.3" width="33.1" height="5" />
		<rect className="fg" x="620.55" y="189.3" width="31" height="5" />
		<polygon
			className="fg"
			points="683.25 147.5 678.25 147.5 678.25 67.1 860.05 67.1 860.05 72.1 683.25 72.1 683.25 147.5"
		/>
		<rect className="fg" x="793.85" y="69.6" width="5" height="78.4" />
		<rect
			className="fg"
			x="552.6"
			y="381.47"
			width="5"
			height="37.57"
			transform="translate(-22.13 767.86) rotate(-68.28)"
		/>
	</svg>
)
